<template>
  <div class="lp">
    <!-- NAV -->
    <nav class="lp-nav">
      <div class="lp-nav-inner">
        <div class="lp-logo" style="cursor:pointer" @click="$router.push('/landing')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="#FF771C"/>
          </svg>
          <span class="lp-logo-text">Elev<span class="lp-logo-ment">Ment</span></span>
        </div>
        <div class="lp-nav-links">
          <a href="#" class="lp-nav-link" @click.prevent="scrollTo('plataforma')">{{ t('nav_platform') }}</a>
          <a href="#" class="lp-nav-link" @click.prevent="scrollTo('como-funciona')">{{ t('nav_how') }}</a>
          <a href="#" class="lp-nav-link" @click.prevent="scrollTo('metricas')">{{ t('nav_metrics') }}</a>
          <a href="#" class="lp-nav-link" @click.prevent="scrollTo('ia-secao')">{{ t('nav_ia') }}</a>
        </div>
        <div class="lp-nav-right">
          <div class="lp-lang">
            <button :class="['lp-lang-btn', lang === 'PT' && 'lp-lang-active']" @click="setLang('PT')">PT</button>
            <button :class="['lp-lang-btn', lang === 'EN' && 'lp-lang-active']" @click="setLang('EN')">EN</button>
            <button :class="['lp-lang-btn', lang === 'ES' && 'lp-lang-active']" @click="setLang('ES')">ES</button>
          </div>
          <button class="lp-btn-outline-sm" @click="$router.push('/login')">{{ t('nav_login') }}</button>
          <button class="lp-btn-orange-sm" @click="openDemo">{{ t('nav_demo') }}</button>
        </div>
        <button class="lp-hamburger" @click="mobileMenu = !mobileMenu">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M3 12H21M3 6H21M3 18H21" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div v-if="mobileMenu" class="lp-mobile-menu">
        <a href="#" class="lp-mobile-link" @click.prevent="scrollTo('plataforma'); mobileMenu = false">{{ t('mob_platform') }}</a>
        <a href="#" class="lp-mobile-link" @click.prevent="scrollTo('como-funciona'); mobileMenu = false">{{ t('mob_how') }}</a>
        <a href="#" class="lp-mobile-link" @click.prevent="scrollTo('metricas'); mobileMenu = false">{{ t('mob_metrics') }}</a>
        <a href="#" class="lp-mobile-link" @click.prevent="scrollTo('ia-secao'); mobileMenu = false">{{ t('mob_ia') }}</a>
        <div class="lp-mobile-btns">
          <button class="lp-btn-outline-sm" @click="$router.push('/login'); mobileMenu = false">{{ t('nav_login') }}</button>
          <button class="lp-btn-orange-sm" @click="openDemo(); mobileMenu = false">{{ t('nav_demo') }}</button>
        </div>
      </div>
    </nav>

    <!-- HERO -->
    <section id="plataforma" class="lp-hero">
      <div class="lp-hero-glow"></div>
      <div class="lp-hero-inner">
         <!-- <div class="lp-hero-pill">
          <span class="lp-pill-dot"></span>
          {{ t('hero_pill') }}
        </div> -->
        <h1 class="lp-hero-h1" v-html="t('hero_h1')"></h1>
        <p class="lp-hero-sub" v-html="t('hero_sub')"></p>
        <div class="lp-hero-ctas">
          <button class="lp-cta-primary" @click="openDemo">{{ t('hero_cta1') }}</button>
          <button class="lp-cta-ghost" @click="scrollTo('como-funciona')">{{ t('hero_cta2') }}</button>
        </div>
        <div class="lp-hero-disclaimer" v-html="t('hero_disclaimer')"></div>
        <div class="lp-hero-mock-wrap">
          <div class="lp-mock">
            <div class="lp-mock-bar">
              <div class="lp-mock-dots"><span></span><span></span><span></span></div>
              <span class="lp-mock-path">ElevMent · Engineering / <b>{{ t('mock_overview') }}</b></span>
            </div>
            <div class="lp-mock-kpis">
              <div class="lp-kpi">
                <div class="lp-kpi-top"><span class="lp-kpi-label">{{ t('mock_lead_time') }}</span><span class="lp-kpi-i">ⓘ</span></div>
                <div class="lp-kpi-val">3.2d</div>
                <svg viewBox="0 0 80 20" class="lp-spark" preserveAspectRatio="none"><polyline points="0,15 13,12 26,14 39,8 53,10 66,5 80,3" fill="none" stroke="#FF771C" stroke-width="1.5"/></svg>
              </div>
              <div class="lp-kpi">
                <div class="lp-kpi-top"><span class="lp-kpi-label">{{ t('mock_review') }}</span><span class="lp-kpi-i">ⓘ</span></div>
                <div class="lp-kpi-val">4h12m</div>
                <svg viewBox="0 0 80 20" class="lp-spark" preserveAspectRatio="none"><polyline points="0,13 13,16 26,10 39,14 53,8 66,12 80,7" fill="none" stroke="#FF771C" stroke-width="1.5"/></svg>
              </div>
              <div class="lp-kpi">
                <div class="lp-kpi-top"><span class="lp-kpi-label">{{ t('mock_deploys') }}</span><span class="lp-kpi-i">ⓘ</span></div>
                <div class="lp-kpi-val">6.4</div>
                <svg viewBox="0 0 80 20" class="lp-spark" preserveAspectRatio="none"><polyline points="0,17 13,14 26,15 39,10 53,12 66,7 80,5" fill="none" stroke="#FF771C" stroke-width="1.5"/></svg>
              </div>
              <div class="lp-kpi">
                <div class="lp-kpi-top"><span class="lp-kpi-label">{{ t('mock_ia_adopt') }}</span><span class="lp-kpi-i">ⓘ</span></div>
                <div class="lp-kpi-val">68%</div>
                <svg viewBox="0 0 80 20" class="lp-spark" preserveAspectRatio="none"><polyline points="0,16 13,14 26,12 39,10 53,8 66,6 80,3" fill="none" stroke="#FF771C" stroke-width="1.5"/></svg>
              </div>
            </div>
            <div class="lp-mock-charts">
              <div class="lp-mock-chart">
                <div class="lp-chart-title">{{ t('mock_flow') }} <span class="lp-chart-sub">{{ t('mock_flow_sub') }}</span></div>
                <svg viewBox="0 0 240 75" class="lp-chart-svg" preserveAspectRatio="none">
                  <defs><linearGradient id="lg1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#FF771C" stop-opacity="0.2"/><stop offset="100%" stop-color="#FF771C" stop-opacity="0"/></linearGradient></defs>
                  <path d="M0,55 C30,50 50,40 70,45 C90,50 110,28 130,23 C150,18 170,38 190,32 C210,26 225,18 240,13 L240,75 L0,75Z" fill="url(#lg1)"/>
                  <path d="M0,55 C30,50 50,40 70,45 C90,50 110,28 130,23 C150,18 170,38 190,32 C210,26 225,18 240,13" fill="none" stroke="#FF771C" stroke-width="1.5"/>
                  <text x="5" y="73" font-size="7" fill="#555">S2</text><text x="35" y="73" font-size="7" fill="#555">S3</text><text x="65" y="73" font-size="7" fill="#555">S4</text><text x="95" y="73" font-size="7" fill="#555">S5</text><text x="125" y="73" font-size="7" fill="#555">S6</text><text x="155" y="73" font-size="7" fill="#555">S7</text><text x="185" y="73" font-size="7" fill="#555">S8</text>
                </svg>
              </div>
              <div class="lp-mock-chart">
                <div class="lp-chart-title">{{ t('mock_ia_chart') }} <span class="lp-chart-sub">{{ t('mock_ia_chart_sub') }}</span></div>
                <svg viewBox="0 0 200 75" class="lp-chart-svg" preserveAspectRatio="none">
                  <rect x="8" y="12" width="26" height="54" rx="3" fill="#FF771C"/><rect x="46" y="28" width="26" height="38" rx="3" fill="#FF771C"/><rect x="84" y="8" width="26" height="58" rx="3" fill="#FF771C"/><rect x="122" y="22" width="26" height="44" rx="3" fill="#FF771C" opacity="0.7"/><rect x="160" y="34" width="26" height="32" rx="3" fill="#FF771C" opacity="0.5"/>
                  <text x="14" y="73" font-size="7" fill="#555">Web</text><text x="49" y="73" font-size="7" fill="#555">Mobile</text><text x="89" y="73" font-size="7" fill="#555">Data</text><text x="122" y="73" font-size="7" fill="#555">Platform</text><text x="165" y="73" font-size="7" fill="#555">QA</text>
                </svg>
              </div>
            </div>
            <div class="lp-mock-time">
              <div class="lp-time-title">{{ t('mock_time_title') }}<span class="lp-kpi-i" style="margin-left:6px">ⓘ</span></div>
              <div class="lp-time-row"><span class="lp-time-label">{{ t('mock_time1') }}</span><div class="lp-time-track"><div class="lp-time-fill" style="width:42%"></div></div><span class="lp-time-pct">42%</span></div>
              <div class="lp-time-row"><span class="lp-time-label">{{ t('mock_time2') }}</span><div class="lp-time-track"><div class="lp-time-fill" style="width:22%"></div></div><span class="lp-time-pct">22%</span></div>
              <div class="lp-time-row"><span class="lp-time-label">{{ t('mock_time3') }}</span><div class="lp-time-track"><div class="lp-time-fill" style="width:16%"></div></div><span class="lp-time-pct">16%</span></div>
              <div class="lp-time-row"><span class="lp-time-label">{{ t('mock_time4') }}</span><div class="lp-time-track"><div class="lp-time-fill" style="width:11%"></div></div><span class="lp-time-pct">11%</span></div>
              <div class="lp-time-row"><span class="lp-time-label">{{ t('mock_time5') }}</span><div class="lp-time-track"><div class="lp-time-fill" style="width:9%"></div></div><span class="lp-time-pct">9%</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- O PROBLEMA -->
    <section id="problema" class="lp-problema">
      <div class="lp-section-inner">
        <div class="lp-section-label">{{ t('prob_label') }}</div>
        <h2 class="lp-problema-h2" v-html="t('prob_h2')"></h2>
        <p class="lp-problema-sub" v-html="t('prob_sub')"></p>
        <div class="lp-prob-grid">
          <div class="lp-prob-card"><svg class="lp-prob-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 20h20L12 2z" stroke="#FF771C" stroke-width="2" stroke-linejoin="round"/><line x1="12" y1="9" x2="12" y2="14" stroke="#FF771C" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.5" r="0.5" fill="#FF771C" stroke="#FF771C"/></svg>{{ t('prob1') }}</div>
          <div class="lp-prob-card"><svg class="lp-prob-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 20h20L12 2z" stroke="#FF771C" stroke-width="2" stroke-linejoin="round"/><line x1="12" y1="9" x2="12" y2="14" stroke="#FF771C" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.5" r="0.5" fill="#FF771C" stroke="#FF771C"/></svg>{{ t('prob2') }}</div>
          <div class="lp-prob-card"><svg class="lp-prob-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 20h20L12 2z" stroke="#FF771C" stroke-width="2" stroke-linejoin="round"/><line x1="12" y1="9" x2="12" y2="14" stroke="#FF771C" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.5" r="0.5" fill="#FF771C" stroke="#FF771C"/></svg>{{ t('prob3') }}</div>
          <div class="lp-prob-card"><svg class="lp-prob-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 20h20L12 2z" stroke="#FF771C" stroke-width="2" stroke-linejoin="round"/><line x1="12" y1="9" x2="12" y2="14" stroke="#FF771C" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.5" r="0.5" fill="#FF771C" stroke="#FF771C"/></svg>{{ t('prob4') }}</div>
          <div class="lp-prob-card"><svg class="lp-prob-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 20h20L12 2z" stroke="#FF771C" stroke-width="2" stroke-linejoin="round"/><line x1="12" y1="9" x2="12" y2="14" stroke="#FF771C" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.5" r="0.5" fill="#FF771C" stroke="#FF771C"/></svg>{{ t('prob5') }}</div>
          <div class="lp-prob-card"><svg class="lp-prob-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 20h20L12 2z" stroke="#FF771C" stroke-width="2" stroke-linejoin="round"/><line x1="12" y1="9" x2="12" y2="14" stroke="#FF771C" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.5" r="0.5" fill="#FF771C" stroke="#FF771C"/></svg>{{ t('prob6') }}</div>
        </div>
      </div>
    </section>

    <!-- COMO FUNCIONA -->
    <section id="como-funciona" class="lp-como">
      <div class="lp-section-inner">
        <div class="lp-section-label">{{ t('how_label') }}</div>
        <h2 class="lp-como-h2">{{ t('how_h2') }}</h2>
        <div class="lp-como-steps">
          <div class="lp-como-step">
            <span class="lp-step-num">01</span>
            <div class="lp-step-icon-wrap"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg></div>
            <h3 class="lp-step-title">{{ t('step1_title') }}</h3>
            <p class="lp-step-desc">{{ t('step1_desc') }}</p>
          </div>
          <div class="lp-como-step">
            <span class="lp-step-num">02</span>
            <div class="lp-step-icon-wrap"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></div>
            <h3 class="lp-step-title">{{ t('step2_title') }}</h3>
            <p class="lp-step-desc">{{ t('step2_desc') }}</p>
          </div>
          <div class="lp-como-step">
            <span class="lp-step-num">03</span>
            <div class="lp-step-icon-wrap"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></div>
            <h3 class="lp-step-title">{{ t('step3_title') }}</h3>
            <p class="lp-step-desc">{{ t('step3_desc') }}</p>
          </div>
        </div>
        <div class="lp-dif-card">
          <div class="lp-dif-left">
            <div class="lp-section-label">{{ t('dif_label') }}</div>
            <h3 class="lp-dif-h3">{{ t('dif_h3') }}</h3>
          </div>
          <div class="lp-dif-right">
            <div class="lp-dif-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#FF771C" stroke-width="1.5"/><path d="M8 12l3 3 5-5" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>{{ t('dif1') }}</span></div>
            <div class="lp-dif-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#FF771C" stroke-width="1.5"/><path d="M8 12l3 3 5-5" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>{{ t('dif2') }}</span></div>
            <div class="lp-dif-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#FF771C" stroke-width="1.5"/><path d="M8 12l3 3 5-5" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>{{ t('dif3') }}</span></div>
            <div class="lp-dif-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#FF771C" stroke-width="1.5"/><path d="M8 12l3 3 5-5" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>{{ t('dif4') }}</span></div>
            <div class="lp-dif-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#FF771C" stroke-width="1.5"/><path d="M8 12l3 3 5-5" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>{{ t('dif5') }}</span></div>
            <div class="lp-dif-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#FF771C" stroke-width="1.5"/><path d="M8 12l3 3 5-5" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>{{ t('dif6') }}</span></div>
          </div>
        </div>
      </div>
    </section>

    <!-- MÉTRICAS -->
    <section id="metricas" class="lp-metricas">
      <div class="lp-section-inner">
        <div class="lp-section-label">{{ t('met_label') }}</div>
        <h2 class="lp-met-h2" v-html="t('met_h2')"></h2>
        <div class="lp-met-grid">
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><path d="M12 22V12M12 12C12 12 7 9 7 5a5 5 0 0 1 10 0c0 4-5 7-5 7z"/></svg></div><span>{{ t('met1') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 15"/></svg></div><span>{{ t('met2') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div><span>{{ t('met3') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><path d="M13 6h3a2 2 0 0 1 2 2v7"/><line x1="6" y1="9" x2="6" y2="21"/></svg></div><span>{{ t('met4') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg></div><span>{{ t('met5') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></div><span>{{ t('met6') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.49"/></svg></div><span>{{ t('met7') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg></div><span>{{ t('met8') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg></div><span>{{ t('met9') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></div><span>{{ t('met10') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg></div><span>{{ t('met11') }}</span></div>
          <div class="lp-met-card"><div class="lp-met-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div><span>{{ t('met12') }}</span></div>
        </div>
      </div>
    </section>

    <!-- ADOÇÃO DE IA -->
    <section id="ia-secao" class="lp-ia">
      <div class="lp-ia-inner">
        <div class="lp-ia-top">
          <div class="lp-section-label" style="display:flex;align-items:center;gap:8px">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            {{ t('ia_label') }}
          </div>
          <h2 class="lp-ia-h2" v-html="t('ia_h2')"></h2>
          <p class="lp-ia-sub">{{ t('ia_sub') }}</p>
        </div>
        <div class="lp-ia-kpis">
          <div class="lp-ia-kpi">
            <div class="lp-ia-kpi-val">10.6x</div>
            <div class="lp-ia-kpi-label">{{ t('ia_kpi1') }}</div>
          </div>
          <div class="lp-ia-kpi">
            <div class="lp-ia-kpi-val">+7pp</div>
            <div class="lp-ia-kpi-label">{{ t('ia_kpi2') }}</div>
          </div>
          <div class="lp-ia-kpi">
            <div class="lp-ia-kpi-val">1.412h</div>
            <div class="lp-ia-kpi-label">{{ t('ia_kpi3') }}</div>
          </div>
          <div class="lp-ia-kpi">
            <div class="lp-ia-kpi-val">R$ 192k</div>
            <div class="lp-ia-kpi-label">{{ t('ia_kpi4') }}</div>
          </div>
        </div>
        <div class="lp-ia-feats-label">{{ t('ia_feats_label') }}</div>
        <div class="lp-ia-feats">
          <div class="lp-ia-feat">
            <div class="lp-ia-feat-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></div>
            <div class="lp-ia-feat-body">
              <h4 class="lp-ia-feat-title">{{ t('ia_feat1_title') }}</h4>
              <p class="lp-ia-feat-desc">{{ t('ia_feat1_desc') }}</p>
            </div>
          </div>
          <div class="lp-ia-feat">
            <div class="lp-ia-feat-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/><line x1="8" y1="10" x2="8.01" y2="10"/><line x1="12" y1="10" x2="12.01" y2="10"/></svg></div>
            <div class="lp-ia-feat-body">
              <h4 class="lp-ia-feat-title">{{ t('ia_feat2_title') }}</h4>
              <p class="lp-ia-feat-desc">{{ t('ia_feat2_desc') }}</p>
            </div>
          </div>
          <div class="lp-ia-feat">
            <div class="lp-ia-feat-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg></div>
            <div class="lp-ia-feat-body">
              <h4 class="lp-ia-feat-title">{{ t('ia_feat3_title') }}</h4>
              <p class="lp-ia-feat-desc">{{ t('ia_feat3_desc') }}</p>
            </div>
          </div>
          <div class="lp-ia-feat">
            <div class="lp-ia-feat-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF771C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg></div>
            <div class="lp-ia-feat-body">
              <h4 class="lp-ia-feat-title">{{ t('ia_feat4_title') }}</h4>
              <p class="lp-ia-feat-desc">{{ t('ia_feat4_desc') }}</p>
            </div>
          </div>
        </div>
        <div class="lp-ia-tools">
          <span class="lp-ia-tools-label">{{ t('ia_tools_label') }}</span>
          <div class="lp-ia-tools-list">
            <span class="lp-ia-tool">GitHub Copilot</span>
            <span class="lp-ia-tool">Cursor</span>
            <span class="lp-ia-tool">ChatGPT</span>
            <span class="lp-ia-tool">Claude</span>
            <span class="lp-ia-tool">Codeium</span>
          </div>
        </div>
      </div>
    </section>

    <!-- PARA QUEM -->
    <section class="lp-paraquem">
      <div class="lp-pq-inner">
        <div class="lp-pq-img-wrap">
          <img src="/para-quem.jpg" :alt="t('pq_img_alt')" class="lp-pq-img">
        </div>
        <div class="lp-pq-content">
          <div class="lp-section-label">{{ t('pq_label') }}</div>
          <h2 class="lp-pq-h2" v-html="t('pq_h2')"></h2>
          <div class="lp-pq-tags">
            <span class="lp-pq-tag">{{ t('pq_tag1') }}</span>
            <span class="lp-pq-tag">{{ t('pq_tag2') }}</span>
            <span class="lp-pq-tag">{{ t('pq_tag3') }}</span>
            <span class="lp-pq-tag">{{ t('pq_tag4') }}</span>
            <span class="lp-pq-tag" v-html="t('pq_tag5')"></span>
            <span class="lp-pq-tag">{{ t('pq_tag6') }}</span>
            <span class="lp-pq-tag">{{ t('pq_tag7') }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA FINAL -->
    <section class="lp-cta-final">
      <div class="lp-cta-final-inner">
        <h2 class="lp-cta-final-h2" v-html="t('cta_h2')"></h2>
        <p class="lp-cta-final-sub">{{ t('cta_sub') }}</p>
        <div class="lp-cta-final-btns">
          <button class="lp-cta-primary" @click="openDemo">{{ t('cta_btn1') }}</button>
          <button class="lp-cta-vendas" @click="openDemo">{{ t('cta_btn2') }}</button>
        </div>
      </div>
    </section>
    
<footer class="lp-footer" style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 24px; padding: 40px 20px;">
      
      <div style="display: flex; align-items: center; justify-content: center; gap: 40px; flex-wrap: wrap;">
        
        <img 
          src="@/assets/images/founders.png" 
          width="160" 
          alt="ElevMent Founders" 
          style="opacity: 0.85; object-fit: contain; transition: opacity 0.2s;"
          onmouseover="this.style.opacity='1'" 
          onmouseout="this.style.opacity='0.85'"
        />

        <img 
          src="@/assets/images/oracle.png" 
          width="160" 
          alt="Oracle Partnership" 
          style="opacity: 0.85; object-fit: contain; transition: opacity 0.2s;"
          onmouseover="this.style.opacity='1'" 
          onmouseout="this.style.opacity='0.85'"
        />

      </div>
      
      <span class="lp-footer-copy" style="font-size: 13px; color: rgba(255,255,255,0.4); text-align: center;">
        {{ t('footer') }}
      </span>
      
    </footer>

    <!-- PLACEHOLDER ancora eng-pessoas --><section id="eng-pessoas" style="display:none"></section>

    <!-- Demo Dialog -->
    <div v-if="showDemoDialog" class="demo-overlay" @click.self="closeDemo">
      <div class="demo-dialog">
        <button class="demo-close" @click="closeDemo">&times;</button>

        <!-- Estado: Sucesso -->
        <div v-if="demoSuccess" class="demo-success">
          <div class="demo-success-icon">✓</div>
          <h2 class="demo-dialog-title">{{ t('demo_success_title') }}</h2>
          <p class="demo-dialog-sub">{{ t('demo_success_sub') }}</p>
          <button class="demo-submit" @click="closeDemo">{{ t('demo_close') }}</button>
        </div>

        <!-- Estado: Formulário -->
        <template v-else>
          <h2 class="demo-dialog-title">{{ t('demo_title') }}</h2>
          <p class="demo-dialog-sub">{{ t('demo_sub') }}</p>

          <div v-if="demoError" class="demo-error-msg">{{ demoError }}</div>

          <div class="demo-field">
            <label>{{ t('demo_name') }}</label>
            <input v-model="demoForm.name" type="text" :placeholder="t('demo_name_ph')" maxlength="100" autocomplete="name" :disabled="demoLoading">
          </div>
          <div class="demo-field">
            <label>{{ t('demo_email') }}</label>
            <input v-model="demoForm.email" type="email" placeholder="email@empresa.com" maxlength="254" autocomplete="email" :disabled="demoLoading">
          </div>
          <div class="demo-field">
            <label>{{ t('demo_company') }}</label>
            <input v-model="demoForm.company" type="text" :placeholder="t('demo_company_ph')" maxlength="120" autocomplete="organization" :disabled="demoLoading">
          </div>
          <div class="demo-field">
            <label>{{ t('demo_phone') }}</label>
            <input
              v-model="demoForm.phone"
              type="tel"
              placeholder="(00) 00000-0000"
              maxlength="15"
              autocomplete="tel"
              :disabled="demoLoading"
              @input="maskPhone"
            >
          </div>
          <div class="demo-field">
            <label>{{ t('demo_team') }}</label>
            <select v-model="demoForm.teamSize" :disabled="demoLoading">
              <option value="">{{ t('demo_team_ph') }}</option>
              <option value="1-10">{{ t('demo_team1') }}</option>
              <option value="11-50">{{ t('demo_team2') }}</option>
              <option value="51-200">{{ t('demo_team3') }}</option>
              <option value="200+">{{ t('demo_team4') }}</option>
            </select>
          </div>
          <button class="demo-submit" :disabled="demoLoading" @click="submitDemo">
            <span v-if="demoLoading" class="demo-spinner"></span>
            {{ demoLoading ? t('demo_sending') : t('demo_submit') }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:8080'

// Limites de comprimento por campo
const FIELD_LIMITS = { name: 100, email: 254, company: 120, phone: 20 }

// Remove qualquer tag HTML/JS e caracteres de controle
function sanitize(str) {
  if (typeof str !== 'string') return ''
  return str
    .replace(/<[^>]*>/g, '')           // strip HTML tags
    .replace(/[<>"'`]/g, '')           // strip remaining dangerous chars
    .replace(/[\x00-\x1F\x7F]/g, '')   // strip control characters
    .trim()
}

const LP_TR = {
  PT: {
    nav_platform: 'Plataforma', nav_how: 'Como funciona', nav_metrics: 'Métricas', nav_ia: 'IA',
    nav_login: 'Entrar', nav_demo: 'Solicitar demo',
    hero_pill: 'Plataforma de Inteligência de Engenharia',
    hero_h1: 'Inteligência de engenharia para<br>times que querem <span class="lp-hero-muted">entregar<br>melhor</span>',
    hero_sub: 'A ElevMent conecta dados de <span class="lp-hl">GitHub</span>, <span class="lp-hl">Jira</span>, <span class="lp-hl">GitLab</span>, <span class="lp-hl">Bitbucket</span>, CI/CD e plataformas de IA para mostrar onde estão os gargalos, como os times estão entregando e quais ações podem melhorar produtividade, qualidade e experiência dos desenvolvedores.',
    hero_cta1: 'Solicitar demonstração', hero_cta2: 'Ver como funciona →',
    hero_disclaimer: 'Sem cartão de crédito &nbsp;●&nbsp; Setup em minutos',
    mock_overview: 'Visão Geral', mock_lead_time: 'LEAD TIME', mock_review: 'TEMPO DE REVIEW',
    mock_deploys: 'DEPLOYS / DIA', mock_ia_adopt: 'ADOÇÃO DE IA',
    mock_flow: 'Fluxo de entrega', mock_flow_sub: '— últimas 8 semanas',
    mock_ia_chart: 'Adoção de IA', mock_ia_chart_sub: 'por time',
    mock_time_title: 'Onde o tempo está indo', mock_time1: 'Code review',
    mock_time2: 'Aguardando merge', mock_time3: 'CI / Testes', mock_time4: 'QA handoff', mock_time5: 'Fila de deploy',
    prob_label: 'O PROBLEMA',
    prob_h2: 'Empresas estão investindo em tecnologia e IA,<br>mas ainda têm pouca visibilidade sobre a engenharia.',
    prob_sub: 'Times usam GitHub, Jira, GitLab, Bitbucket, pipelines e ferramentas de IA todos os dias.<br>Mesmo assim, muitas lideranças ainda têm dificuldade para responder perguntas simples:',
    prob1: 'Onde o fluxo de entrega está travando?', prob2: 'O tempo de review está alto?',
    prob3: 'Os PRs estão grandes demais?', prob4: 'A adoção de IA está gerando produtividade real?',
    prob5: 'O time está melhorando qualidade ou acumulando retrabalho?', prob6: 'Quais iniciativas estão em risco?',
    how_label: 'COMO FUNCIONA', how_h2: 'Três passos para visibilidade de verdade.',
    step1_title: 'Conecte suas ferramentas',
    step1_desc: 'Integre dados de GitHub, GitLab, Bitbucket, Jira, CI/CD e ferramentas de IA em minutos.',
    step2_title: 'Entenda os gargalos',
    step2_desc: 'A plataforma identifica padrões, riscos, atrasos, retrabalho e pontos de bloqueio no fluxo.',
    step3_title: 'Transforme insights em ação',
    step3_desc: 'Recomendações práticas para melhorar produtividade, qualidade, colaboração e DevEx.',
    dif_label: 'DIFERENCIAIS',
    dif_h3: 'Mais intuitiva que dashboards complexos. Mais prática que relatórios manuais.',
    dif1: 'Diagnósticos claros, não apenas gráficos',
    dif2: 'Visão para CTOs, Heads, Tech Leads e Engineering Managers',
    dif3: 'Métricas conectadas a ações práticas',
    dif4: 'Foco em melhorar o sistema, não vigiar pessoas',
    dif5: 'Insights de produtividade, qualidade, DevEx e IA',
    dif6: 'Interface simples, moderna e fácil de entender',
    met_label: 'MÉTRICAS', met_h2: 'As métricas que realmente importam<br>para engenharia.',
    met1: 'Lead Time', met2: 'Cycle Time', met3: 'Tempo médio de review', met4: 'Pull Requests parados',
    met5: 'Deploy Frequency', met6: 'Change Failure Rate', met7: 'Retrabalho', met8: 'Gargalos por etapa',
    met9: 'WIP por time', met10: 'Impacto da adoção de IA', met11: 'Risco de entrega', met12: 'Saúde do fluxo',
    ia_label: 'ADOÇÃO DE IA',
    ia_h2: 'Sua empresa comprou IA. <span class="lp-ia-muted">Agora precisa provar valor.</span>',
    ia_sub: 'A ElevMent mostra se a adoção de IA está realmente melhorando a produtividade dos times. Mais do que medir uso, conectamos dados de engenharia para revelar impacto real no fluxo de entrega, qualidade, retrabalho e velocidade.',
    ia_kpi1: 'ROI comprovado sobre o investimento em IA', ia_kpi2: 'Adoção ativa vs. mês anterior (68%)',
    ia_kpi3: 'Capacidade extra recuperada por mês', ia_kpi4: 'Retorno líquido gerado por mês',
    ia_feats_label: 'O poder da ElevMent para acelerar a adoção de IA',
    ia_feat1_title: 'Adoção real por pessoa, time e ferramenta',
    ia_feat1_desc: 'Veja quem usa, com que frequência e onde a adoção emperra — de Copilot a Cursor, Claude e ChatGPT.',
    ia_feat2_title: 'Utilização de licenças e desperdício',
    ia_feat2_desc: 'Identifique assentos ociosos e licenças pagas sem uso para realocar investimento e cortar custo.',
    ia_feat3_title: 'Impacto real no fluxo de entrega',
    ia_feat3_desc: 'Conecte adoção de IA a lead time, retrabalho e qualidade — prove ganho de produtividade, não só uso.',
    ia_feat4_title: 'Funil de adoção, do provisionado ao uso diário',
    ia_feat4_desc: 'Acompanhe a jornada: licença provisionada, primeira ativação, uso semanal e power users diários.',
    ia_tools_label: 'Integra com as principais ferramentas de IA:',
    pq_label: 'PARA QUEM', pq_img_alt: 'Times de tecnologia',
    pq_h2: 'Feita para quem lidera e<br>melhora times de tecnologia.',
    pq_tag1: 'CTOs', pq_tag2: 'Heads de Engenharia', pq_tag3: 'Engineering Managers', pq_tag4: 'Tech Leads',
    pq_tag5: 'Product &amp; Delivery Managers', pq_tag6: 'Times de plataforma',
    pq_tag7: 'Empresas adotando IA no desenvolvimento',
    cta_h2: 'Descubra o que está travando <span class="lp-cta-final-muted">sua engenharia.</span>',
    cta_sub: 'Conecte suas ferramentas, visualize seus gargalos e transforme dados de engenharia em decisões práticas para melhorar produtividade, qualidade e experiência dos desenvolvedores.',
    cta_btn1: 'Solicitar demonstração', cta_btn2: 'Falar com vendas →',
    footer: '© 2026 ElevMent — Inteligência de Engenharia',
    demo_title: 'Agendar uma demonstração',
    demo_sub: 'Preencha seus dados e entraremos em contato em até 24h.',
    demo_success_title: 'Solicitação enviada!',
    demo_success_sub: 'Entraremos em contato em até 24h pelo e-mail informado.',
    demo_close: 'Fechar', demo_name: 'Nome completo', demo_name_ph: 'Seu nome',
    demo_email: 'E-mail corporativo', demo_company: 'Empresa', demo_company_ph: 'Nome da empresa',
    demo_phone: 'Telefone', demo_team: 'Tamanho do time', demo_team_ph: 'Selecione',
    demo_team1: '1 - 10 pessoas', demo_team2: '11 - 50 pessoas',
    demo_team3: '51 - 200 pessoas', demo_team4: '200+ pessoas',
    demo_submit: 'Agendar demonstração', demo_sending: 'Enviando...',
    mob_platform: 'Plataforma', mob_how: 'Como funciona', mob_metrics: 'Métricas', mob_ia: 'IA',
  },
  EN: {
    nav_platform: 'Platform', nav_how: 'How it works', nav_metrics: 'Metrics', nav_ia: 'AI',
    nav_login: 'Sign in', nav_demo: 'Request demo',
    hero_pill: 'Engineering Intelligence Platform',
    hero_h1: 'Engineering intelligence for<br>teams that want to <span class="lp-hero-muted">deliver<br>better</span>',
    hero_sub: 'ElevMent connects data from <span class="lp-hl">GitHub</span>, <span class="lp-hl">Jira</span>, <span class="lp-hl">GitLab</span>, <span class="lp-hl">Bitbucket</span>, CI/CD and AI platforms to show where bottlenecks are, how teams are delivering and what actions can improve productivity, quality and developer experience.',
    hero_cta1: 'Request a demo', hero_cta2: 'See how it works →',
    hero_disclaimer: 'No credit card required &nbsp;●&nbsp; Setup in minutes',
    mock_overview: 'Overview', mock_lead_time: 'LEAD TIME', mock_review: 'REVIEW TIME',
    mock_deploys: 'DEPLOYS / DAY', mock_ia_adopt: 'AI ADOPTION',
    mock_flow: 'Delivery flow', mock_flow_sub: '— last 8 weeks',
    mock_ia_chart: 'AI Adoption', mock_ia_chart_sub: 'by team',
    mock_time_title: 'Where time is going', mock_time1: 'Code review',
    mock_time2: 'Awaiting merge', mock_time3: 'CI / Tests', mock_time4: 'QA handoff', mock_time5: 'Deploy queue',
    prob_label: 'THE PROBLEM',
    prob_h2: 'Companies are investing in technology and AI,<br>but still have little visibility into engineering.',
    prob_sub: 'Teams use GitHub, Jira, GitLab, Bitbucket, pipelines and AI tools every day.<br>Yet many leaders still struggle to answer simple questions:',
    prob1: 'Where is the delivery flow getting stuck?', prob2: 'Is review time too high?',
    prob3: 'Are PRs getting too large?', prob4: 'Is AI adoption driving real productivity?',
    prob5: 'Is the team improving quality or accumulating rework?', prob6: 'Which initiatives are at risk?',
    how_label: 'HOW IT WORKS', how_h2: 'Three steps to real visibility.',
    step1_title: 'Connect your tools',
    step1_desc: 'Integrate data from GitHub, GitLab, Bitbucket, Jira, CI/CD and AI tools in minutes.',
    step2_title: 'Understand the bottlenecks',
    step2_desc: 'The platform identifies patterns, risks, delays, rework and blocking points in the flow.',
    step3_title: 'Turn insights into action',
    step3_desc: 'Practical recommendations to improve productivity, quality, collaboration and DevEx.',
    dif_label: 'DIFFERENTIALS',
    dif_h3: 'More intuitive than complex dashboards. More practical than manual reports.',
    dif1: 'Clear diagnostics, not just charts',
    dif2: 'View for CTOs, Heads, Tech Leads and Engineering Managers',
    dif3: 'Metrics connected to practical actions',
    dif4: 'Focus on improving the system, not surveilling people',
    dif5: 'Insights on productivity, quality, DevEx and AI',
    dif6: 'Simple, modern and easy-to-understand interface',
    met_label: 'METRICS', met_h2: 'The metrics that truly matter<br>for engineering.',
    met1: 'Lead Time', met2: 'Cycle Time', met3: 'Average review time', met4: 'Stalled Pull Requests',
    met5: 'Deploy Frequency', met6: 'Change Failure Rate', met7: 'Rework', met8: 'Bottlenecks by stage',
    met9: 'WIP by team', met10: 'AI adoption impact', met11: 'Delivery risk', met12: 'Flow health',
    ia_label: 'AI ADOPTION',
    ia_h2: 'Your company bought AI. <span class="lp-ia-muted">Now it needs to prove value.</span>',
    ia_sub: 'ElevMent shows whether AI adoption is actually improving team productivity. Beyond measuring usage, we connect engineering data to reveal real impact on delivery flow, quality, rework and speed.',
    ia_kpi1: 'Proven ROI on AI investment', ia_kpi2: 'Active adoption vs. prior month (68%)',
    ia_kpi3: 'Extra capacity recovered per month', ia_kpi4: 'Net return generated per month',
    ia_feats_label: "ElevMent's power to accelerate AI adoption",
    ia_feat1_title: 'Real adoption by person, team and tool',
    ia_feat1_desc: 'See who uses it, how often and where adoption stalls — from Copilot to Cursor, Claude and ChatGPT.',
    ia_feat2_title: 'License utilization and waste',
    ia_feat2_desc: 'Identify idle seats and unused paid licenses to reallocate investment and cut costs.',
    ia_feat3_title: 'Real impact on delivery flow',
    ia_feat3_desc: 'Connect AI adoption to lead time, rework and quality — prove productivity gains, not just usage.',
    ia_feat4_title: 'Adoption funnel, from provisioned to daily use',
    ia_feat4_desc: 'Track the journey: provisioned license, first activation, weekly use and daily power users.',
    ia_tools_label: 'Integrates with leading AI tools:',
    pq_label: 'WHO IS IT FOR', pq_img_alt: 'Technology teams',
    pq_h2: 'Built for those who lead and<br>improve technology teams.',
    pq_tag1: 'CTOs', pq_tag2: 'Engineering Heads', pq_tag3: 'Engineering Managers', pq_tag4: 'Tech Leads',
    pq_tag5: 'Product &amp; Delivery Managers', pq_tag6: 'Platform teams',
    pq_tag7: 'Companies adopting AI in development',
    cta_h2: 'Discover what is blocking <span class="lp-cta-final-muted">your engineering.</span>',
    cta_sub: 'Connect your tools, visualize your bottlenecks and transform engineering data into practical decisions to improve productivity, quality and developer experience.',
    cta_btn1: 'Request a demo', cta_btn2: 'Talk to sales →',
    footer: '© 2026 ElevMent — Engineering Intelligence',
    demo_title: 'Schedule a demo',
    demo_sub: 'Fill in your details and we will get in touch within 24 hours.',
    demo_success_title: 'Request sent!',
    demo_success_sub: 'We will contact you within 24 hours at the provided email.',
    demo_close: 'Close', demo_name: 'Full name', demo_name_ph: 'Your name',
    demo_email: 'Corporate email', demo_company: 'Company', demo_company_ph: 'Company name',
    demo_phone: 'Phone', demo_team: 'Team size', demo_team_ph: 'Select',
    demo_team1: '1 - 10 people', demo_team2: '11 - 50 people',
    demo_team3: '51 - 200 people', demo_team4: '200+ people',
    demo_submit: 'Schedule demo', demo_sending: 'Sending...',
    mob_platform: 'Platform', mob_how: 'How it works', mob_metrics: 'Metrics', mob_ia: 'AI',
  },
  ES: {
    nav_platform: 'Plataforma', nav_how: 'Cómo funciona', nav_metrics: 'Métricas', nav_ia: 'IA',
    nav_login: 'Entrar', nav_demo: 'Solicitar demo',
    hero_pill: 'Plataforma de Inteligencia de Ingeniería',
    hero_h1: 'Inteligencia de ingeniería para<br>equipos que quieren <span class="lp-hero-muted">entregar<br>mejor</span>',
    hero_sub: 'ElevMent conecta datos de <span class="lp-hl">GitHub</span>, <span class="lp-hl">Jira</span>, <span class="lp-hl">GitLab</span>, <span class="lp-hl">Bitbucket</span>, CI/CD y plataformas de IA para mostrar dónde están los cuellos de botella, cómo están entregando los equipos y qué acciones pueden mejorar la productividad, calidad y experiencia de los desarrolladores.',
    hero_cta1: 'Solicitar demostración', hero_cta2: 'Ver cómo funciona →',
    hero_disclaimer: 'Sin tarjeta de crédito &nbsp;●&nbsp; Configuración en minutos',
    mock_overview: 'Vista General', mock_lead_time: 'LEAD TIME', mock_review: 'TIEMPO DE REVISIÓN',
    mock_deploys: 'DEPLOYS / DÍA', mock_ia_adopt: 'ADOPCIÓN DE IA',
    mock_flow: 'Flujo de entrega', mock_flow_sub: '— últimas 8 semanas',
    mock_ia_chart: 'Adopción de IA', mock_ia_chart_sub: 'por equipo',
    mock_time_title: 'A dónde va el tiempo', mock_time1: 'Code review',
    mock_time2: 'Esperando merge', mock_time3: 'CI / Tests', mock_time4: 'QA handoff', mock_time5: 'Cola de deploy',
    prob_label: 'EL PROBLEMA',
    prob_h2: 'Las empresas están invirtiendo en tecnología e IA,<br>pero aún tienen poca visibilidad sobre la ingeniería.',
    prob_sub: 'Los equipos usan GitHub, Jira, GitLab, Bitbucket, pipelines y herramientas de IA todos los días.<br>Sin embargo, muchos líderes aún tienen dificultades para responder preguntas simples:',
    prob1: '¿Dónde se está atascando el flujo de entrega?', prob2: '¿El tiempo de revisión es muy alto?',
    prob3: '¿Los PRs son demasiado grandes?', prob4: '¿La adopción de IA está generando productividad real?',
    prob5: '¿El equipo está mejorando la calidad o acumulando retrabajo?', prob6: '¿Cuáles iniciativas están en riesgo?',
    how_label: 'CÓMO FUNCIONA', how_h2: 'Tres pasos para visibilidad real.',
    step1_title: 'Conecta tus herramientas',
    step1_desc: 'Integra datos de GitHub, GitLab, Bitbucket, Jira, CI/CD y herramientas de IA en minutos.',
    step2_title: 'Entiende los cuellos de botella',
    step2_desc: 'La plataforma identifica patrones, riesgos, retrasos, retrabajo y puntos de bloqueo en el flujo.',
    step3_title: 'Transforma insights en acción',
    step3_desc: 'Recomendaciones prácticas para mejorar productividad, calidad, colaboración y DevEx.',
    dif_label: 'DIFERENCIALES',
    dif_h3: 'Más intuitiva que dashboards complejos. Más práctica que reportes manuales.',
    dif1: 'Diagnósticos claros, no solo gráficos',
    dif2: 'Visión para CTOs, Heads, Tech Leads y Engineering Managers',
    dif3: 'Métricas conectadas a acciones prácticas',
    dif4: 'Enfoque en mejorar el sistema, no vigilar personas',
    dif5: 'Insights de productividad, calidad, DevEx e IA',
    dif6: 'Interfaz simple, moderna y fácil de entender',
    met_label: 'MÉTRICAS', met_h2: 'Las métricas que realmente importan<br>para la ingeniería.',
    met1: 'Lead Time', met2: 'Cycle Time', met3: 'Tiempo promedio de revisión', met4: 'Pull Requests detenidos',
    met5: 'Frecuencia de deploys', met6: 'Change Failure Rate', met7: 'Retrabajo', met8: 'Cuellos de botella por etapa',
    met9: 'WIP por equipo', met10: 'Impacto de adopción de IA', met11: 'Riesgo de entrega', met12: 'Salud del flujo',
    ia_label: 'ADOPCIÓN DE IA',
    ia_h2: 'Tu empresa compró IA. <span class="lp-ia-muted">Ahora necesita probar valor.</span>',
    ia_sub: 'ElevMent muestra si la adopción de IA está realmente mejorando la productividad de los equipos. Más que medir el uso, conectamos datos de ingeniería para revelar el impacto real en el flujo de entrega, calidad, retrabajo y velocidad.',
    ia_kpi1: 'ROI comprobado sobre la inversión en IA', ia_kpi2: 'Adopción activa vs. mes anterior (68%)',
    ia_kpi3: 'Capacidad extra recuperada por mes', ia_kpi4: 'Retorno neto generado por mes',
    ia_feats_label: 'El poder de ElevMent para acelerar la adopción de IA',
    ia_feat1_title: 'Adopción real por persona, equipo y herramienta',
    ia_feat1_desc: 'Ve quién usa, con qué frecuencia y dónde se detiene la adopción — de Copilot a Cursor, Claude y ChatGPT.',
    ia_feat2_title: 'Utilización de licencias y desperdicio',
    ia_feat2_desc: 'Identifica asientos inactivos y licencias pagadas sin uso para reasignar inversión y reducir costos.',
    ia_feat3_title: 'Impacto real en el flujo de entrega',
    ia_feat3_desc: 'Conecta la adopción de IA con lead time, retrabajo y calidad — demuestra ganancias de productividad, no solo uso.',
    ia_feat4_title: 'Embudo de adopción, del aprovisionado al uso diario',
    ia_feat4_desc: 'Sigue el viaje: licencia aprovisionada, primera activación, uso semanal y power users diarios.',
    ia_tools_label: 'Se integra con las principales herramientas de IA:',
    pq_label: 'PARA QUIÉN', pq_img_alt: 'Equipos de tecnología',
    pq_h2: 'Creada para quienes lideran y<br>mejoran equipos de tecnología.',
    pq_tag1: 'CTOs', pq_tag2: 'Heads de Ingeniería', pq_tag3: 'Engineering Managers', pq_tag4: 'Tech Leads',
    pq_tag5: 'Product &amp; Delivery Managers', pq_tag6: 'Equipos de plataforma',
    pq_tag7: 'Empresas adoptando IA en desarrollo',
    cta_h2: 'Descubre qué está frenando <span class="lp-cta-final-muted">tu ingeniería.</span>',
    cta_sub: 'Conecta tus herramientas, visualiza tus cuellos de botella y transforma datos de ingeniería en decisiones prácticas para mejorar productividad, calidad y experiencia de los desarrolladores.',
    cta_btn1: 'Solicitar demostración', cta_btn2: 'Hablar con ventas →',
    footer: '© 2026 ElevMent — Inteligencia de Ingeniería',
    demo_title: 'Agendar una demostración',
    demo_sub: 'Completa tus datos y te contactaremos en menos de 24 horas.',
    demo_success_title: '¡Solicitud enviada!',
    demo_success_sub: 'Nos pondremos en contacto en menos de 24 horas al correo proporcionado.',
    demo_close: 'Cerrar', demo_name: 'Nombre completo', demo_name_ph: 'Tu nombre',
    demo_email: 'Correo corporativo', demo_company: 'Empresa', demo_company_ph: 'Nombre de la empresa',
    demo_phone: 'Teléfono', demo_team: 'Tamaño del equipo', demo_team_ph: 'Selecciona',
    demo_team1: '1 - 10 personas', demo_team2: '11 - 50 personas',
    demo_team3: '51 - 200 personas', demo_team4: '200+ personas',
    demo_submit: 'Agendar demostración', demo_sending: 'Enviando...',
    mob_platform: 'Plataforma', mob_how: 'Cómo funciona', mob_metrics: 'Métricas', mob_ia: 'IA',
  },
}

export default {
  name: 'LandingPage',

  data: () => ({
    mobileMenu: false,
    showDemoDialog: false,
    demoLoading: false,
    demoSuccess: false,
    demoError: '',
    demoForm: {
      name: '',
      email: '',
      company: '',
      phone: '',
      teamSize: '',
    },
    demoBoardTool: 'Jira',
    _demoLastSubmit: 0,   // client-side rate limit timestamp
    lang: 'PT',
  }),

  methods: {
    t (key) {
      const tr = LP_TR[this.lang] || LP_TR.PT
      return tr[key] !== undefined ? tr[key] : (LP_TR.PT[key] || key)
    },
    setLang (l) {
      if (LP_TR[l]) this.lang = l
    },

    scrollTo(id) {
      if (id === 'plataforma') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      const el = document.getElementById(id)
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 68
        window.scrollTo({ top, behavior: 'smooth' })
      }
    },

    openDemo() {
      this.showDemoDialog = true
      this.demoSuccess = false
      this.demoError = ''
    },

    submitDemoInline() {
      this.openDemo()
    },


    closeDemo() {
      this.showDemoDialog = false
      if (this.demoSuccess) {
        this.demoForm = { name: '', email: '', company: '', phone: '', teamSize: '' }
        this.demoSuccess = false
      }
      this.demoError = ''
    },

    maskPhone(e) {
      let v = e.target.value.replace(/\D/g, '').substring(0, 11)
      if (v.length > 6) {
        v = `(${v.substring(0, 2)}) ${v.substring(2, 7)}-${v.substring(7)}`
      } else if (v.length > 2) {
        v = `(${v.substring(0, 2)}) ${v.substring(2)}`
      } else if (v.length > 0) {
        v = `(${v}`
      }
      this.demoForm.phone = v
    },

    async submitDemo() {
      // Client-side rate limit: mínimo 30s entre envios
      const now = Date.now()
      if (now - this._demoLastSubmit < 30000) {
        this.demoError = 'Aguarde alguns segundos antes de tentar novamente.'
        return
      }

      // Sanitizar e truncar todos os campos antes de qualquer validação
      const name     = sanitize(this.demoForm.name).substring(0, FIELD_LIMITS.name)
      const email    = sanitize(this.demoForm.email).substring(0, FIELD_LIMITS.email).toLowerCase()
      const company  = sanitize(this.demoForm.company).substring(0, FIELD_LIMITS.company)
      const phone    = sanitize(this.demoForm.phone).substring(0, FIELD_LIMITS.phone)
      const teamSize = this.demoForm.teamSize

      // Validação de campos obrigatórios
      if (!name || !email || !company || !teamSize) {
        this.demoError = 'Preencha todos os campos.'
        return
      }

      // Validação de comprimento mínimo
      if (name.length < 2) {
        this.demoError = 'Informe seu nome completo.'
        return
      }

      // Validação de e-mail (RFC básico + sem domínios suspeitos de teste)
      const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/
      if (!emailRegex.test(email)) {
        this.demoError = 'Informe um e-mail válido.'
        return
      }

      // Bloquear valores de teamSize fora da lista permitida (enum whitelist)
      const allowedSizes = ['1-10', '11-50', '51-200', '200+']
      if (!allowedSizes.includes(teamSize)) {
        this.demoError = 'Selecione um tamanho de time válido.'
        return
      }

      this.demoLoading = true
      this.demoError = ''
      this._demoLastSubmit = Date.now()

      try {
        await axios.post(`${API_BASE_URL}/api/public/demo-requests`, {
          name,
          email,
          company,
          phone: phone || null,
          teamSize,
        }, {
          timeout: 10000, // 10s timeout — evita requests pendentes indefinidamente
          headers: { 'Content-Type': 'application/json' },
        })
        this.demoSuccess = true
      } catch (err) {
        const status = err.response?.status
        if (status === 409) {
          this.demoError = 'Já recebemos sua solicitação. Entraremos em contato em breve.'
        } else if (status === 429) {
          this.demoError = 'Muitas solicitações. Tente novamente em alguns minutos.'
        } else if (err.code === 'ECONNABORTED') {
          this.demoError = 'Tempo de resposta excedido. Verifique sua conexão e tente novamente.'
        } else {
          this.demoError = 'Erro ao enviar solicitação. Tente novamente.'
        }
      } finally {
        this.demoLoading = false
      }
    },
  },
}
</script>

<style scoped>
/* ============================================================
   DARK THEME — NEW SECTIONS
============================================================ */
.lp {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #0A0A0B;
  color: #FFFFFF;
  -webkit-font-smoothing: antialiased;
  min-height: 100vh;
}

/* --- NAV --- */
.lp-nav {
  position: fixed; top: 0; left: 0; right: 0; z-index: 100;
  background: rgba(10,10,11,0.72);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
/* glow laranja saindo de trás da nav */
.lp-nav::before {
  content: '';
  position: absolute;
  top: -40px; left: 50%; transform: translateX(-50%);
  width: 700px; height: 130px;
  background: radial-gradient(ellipse at 50% 0%, rgba(255,119,28,0.22) 0%, transparent 70%);
  pointer-events: none;
  z-index: -1;
}
.lp-nav-inner {
  max-width: 1200px; margin: 0 auto; padding: 0 28px;
  height: 60px; display: flex; align-items: center; gap: 32px;
}
.lp-logo { display: flex; align-items: center; gap: 8px; text-decoration: none; user-select: none; }
.lp-logo-text { font-size: 18px; font-weight: 700; color: #FFFFFF; letter-spacing: -0.01em; }
.lp-logo-ment { color: rgba(255,255,255,0.45); }
.lp-nav-links { display: flex; align-items: center; gap: 28px; flex: 1; }
.lp-nav-link { font-size: 14px; font-weight: 500; color: rgba(255,255,255,0.6); text-decoration: none; transition: color 0.15s; }
.lp-nav-link:hover { color: #FFFFFF; }
.lp-nav-right { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.lp-lang { display: flex; align-items: center; gap: 2px; background: rgba(255,255,255,0.07); border-radius: 6px; padding: 2px; }
.lp-lang-btn { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.45); background: none; border: none; cursor: pointer; padding: 4px 8px; border-radius: 4px; transition: all 0.15s; }
.lp-lang-active { background: #FF771C !important; color: #FFFFFF !important; }
.lp-btn-outline-sm { font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.8); background: transparent; border: 1px solid rgba(255,255,255,0.22); border-radius: 8px; padding: 7px 16px; cursor: pointer; transition: all 0.15s; white-space: nowrap; }
.lp-btn-outline-sm:hover { border-color: rgba(255,255,255,0.5); color: #FFFFFF; }
.lp-btn-orange-sm { font-size: 13px; font-weight: 600; color: #FFFFFF; background: #FF771C; border: none; border-radius: 8px; padding: 7px 16px; cursor: pointer; transition: background 0.15s; white-space: nowrap; }
.lp-btn-orange-sm:hover { background: #E05F00; }
.lp-hamburger { display: none; background: none; border: none; cursor: pointer; padding: 4px; margin-left: auto; }
.lp-mobile-menu { border-top: 1px solid rgba(255,255,255,0.07); padding: 16px 28px 20px; display: flex; flex-direction: column; gap: 14px; }
.lp-mobile-link { font-size: 16px; color: rgba(255,255,255,0.65); text-decoration: none; }
.lp-mobile-btns { display: flex; gap: 10px; padding-top: 6px; flex-wrap: wrap; }

/* --- HERO --- */
.lp-hero {
  position: relative;
  padding: 130px 28px 0;
  overflow: hidden;
}
/* glow difuso atrás do hero text */
.lp-hero-glow {
  position: absolute;
  top: -60px; left: 50%; transform: translateX(-50%);
  width: 900px; height: 500px;
  background: radial-gradient(ellipse at 50% 10%, rgba(255,119,28,0.13) 0%, transparent 65%);
  pointer-events: none;
  z-index: 0;
}
.lp-hero-inner {
  position: relative; z-index: 1;
  max-width: 820px; margin: 0 auto;
  display: flex; flex-direction: column; align-items: center;
  text-align: center; gap: 24px;
}
.lp-hero-pill {
  display: inline-flex; align-items: center; gap: 8px;
  background: rgba(255,119,28,0.1); border: 1px solid rgba(255,119,28,0.28);
  border-radius: 100px; padding: 7px 16px; font-size: 13px;
  color: rgba(255,255,255,0.75);
}
.lp-pill-dot { width: 7px; height: 7px; border-radius: 50%; background: #FF771C; flex-shrink: 0; }
.lp-hero-h1 { font-size: 64px; font-weight: 800; line-height: 1.08; letter-spacing: -0.035em; color: #FFFFFF; margin: 0; }
.lp-hero-muted { color: rgba(255,255,255,0.32); }
.lp-hero-sub { font-size: 17px; line-height: 1.7; color: rgba(255,255,255,0.55); margin: 0; max-width: 640px; }
.lp-hl { color: rgba(255,255,255,0.88); }
.lp-hero-ctas { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; justify-content: center; }
.lp-cta-primary { font-size: 15px; font-weight: 600; color: #FFFFFF; background: #FF771C; border: none; border-radius: 10px; padding: 14px 28px; cursor: pointer; transition: background 0.15s; }
.lp-cta-primary:hover { background: #E05F00; }
.lp-cta-ghost { font-size: 15px; font-weight: 500; color: rgba(255,255,255,0.65); background: transparent; border: 1px solid rgba(255,255,255,0.2); border-radius: 10px; padding: 14px 24px; cursor: pointer; transition: all 0.15s; }
.lp-cta-ghost:hover { color: #FFFFFF; border-color: rgba(255,255,255,0.45); }
.lp-hero-disclaimer { font-size: 13px; color: rgba(255,255,255,0.28); }
.lp-hero-mock-wrap {
  width: 100%; max-width: 780px;
  margin-top: 16px;
  padding-bottom: 0;
}

/* Hero Mockup */
.lp-mock { background: #111113; border: 1px solid rgba(255,255,255,0.1); border-radius: 14px; overflow: hidden; box-shadow: 0 28px 80px rgba(0,0,0,0.55); }
.lp-mock-bar { display: flex; align-items: center; gap: 12px; padding: 10px 16px; background: #0E0E10; border-bottom: 1px solid rgba(255,255,255,0.06); }
.lp-mock-dots { display: flex; gap: 5px; }
.lp-mock-dots span { width: 10px; height: 10px; border-radius: 50%; background: rgba(255,255,255,0.13); }
.lp-mock-path { font-size: 12px; color: rgba(255,255,255,0.38); }
.lp-mock-path b { color: rgba(255,255,255,0.65); font-weight: 500; }
.lp-mock-kpis { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px; background: rgba(255,255,255,0.05); padding: 1px; }
.lp-kpi { background: #111113; padding: 14px 12px 10px; }
.lp-kpi-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px; }
.lp-kpi-label { font-size: 9px; font-weight: 700; letter-spacing: 0.08em; color: rgba(255,255,255,0.38); }
.lp-kpi-i { font-size: 11px; color: rgba(255,255,255,0.2); }
.lp-kpi-val { font-size: 22px; font-weight: 700; color: #FFFFFF; line-height: 1; margin-bottom: 8px; }
.lp-spark { width: 100%; height: 20px; display: block; }
.lp-mock-charts { display: grid; grid-template-columns: 1fr 1fr; gap: 1px; background: rgba(255,255,255,0.05); padding: 0 1px 1px; }
.lp-mock-chart { background: #111113; padding: 12px 14px 10px; }
.lp-chart-title { font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.65); margin-bottom: 6px; }
.lp-chart-sub { color: rgba(255,255,255,0.32); font-weight: 400; }
.lp-chart-svg { width: 100%; height: 75px; display: block; }
.lp-mock-time { padding: 12px 16px 14px; background: #111113; border-top: 1px solid rgba(255,255,255,0.05); }
.lp-time-title { font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.45); margin-bottom: 10px; display: flex; align-items: center; }
.lp-time-row { display: flex; align-items: center; gap: 8px; margin-bottom: 7px; }
.lp-time-label { font-size: 11px; color: rgba(255,255,255,0.5); width: 114px; flex-shrink: 0; }
.lp-time-track { flex: 1; height: 4px; background: rgba(255,255,255,0.08); border-radius: 2px; overflow: hidden; }
.lp-time-fill { height: 100%; background: #FF771C; border-radius: 2px; }
.lp-time-pct { font-size: 11px; color: rgba(255,255,255,0.45); width: 30px; text-align: right; flex-shrink: 0; }

/* --- O PROBLEMA --- */
.lp-problema { border-top: 1px solid rgba(255,255,255,0.06); padding: 96px 28px; }
.lp-section-inner { max-width: 1000px; margin: 0 auto; }
.lp-section-label { font-size: 11px; font-weight: 700; letter-spacing: 0.12em; color: #FF771C; text-transform: uppercase; margin-bottom: 20px; }
.lp-problema-h2 { font-size: 38px; font-weight: 800; line-height: 1.18; letter-spacing: -0.025em; color: #FFFFFF; margin: 0 0 20px; }
.lp-problema-sub { font-size: 16px; line-height: 1.65; color: rgba(255,255,255,0.52); margin: 0 0 48px; }
.lp-prob-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.lp-prob-card { display: flex; align-items: flex-start; gap: 10px; padding: 16px 20px; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; font-size: 14px; color: rgba(255,255,255,0.72); line-height: 1.4; }
.lp-prob-icon { flex-shrink: 0; margin-top: 1px; }

/* --- COMO FUNCIONA --- */
.lp-como { border-top: 1px solid rgba(255,255,255,0.06); padding: 96px 28px; }
.lp-como-h2 { font-size: 38px; font-weight: 800; line-height: 1.15; letter-spacing: -0.025em; color: #FFFFFF; margin: 0 0 52px; }
.lp-como-steps { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 32px; }
.lp-como-step { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 14px; padding: 28px 22px; display: flex; flex-direction: column; gap: 14px; }
.lp-step-num { font-size: 48px; font-weight: 800; color: rgba(255,255,255,0.05); line-height: 1; letter-spacing: -0.04em; align-self: flex-end; margin-top: -6px; }
.lp-step-icon-wrap { width: 44px; height: 44px; background: rgba(255,119,28,0.1); border: 1px solid rgba(255,119,28,0.2); border-radius: 10px; display: flex; align-items: center; justify-content: center; }
.lp-step-title { font-size: 17px; font-weight: 700; color: #FFFFFF; margin: 0; }
.lp-step-desc { font-size: 14px; line-height: 1.6; color: rgba(255,255,255,0.52); margin: 0; }
.lp-dif-card { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 40px 48px; align-items: start; }
.lp-dif-left { display: flex; flex-direction: column; gap: 16px; }
.lp-dif-h3 { font-size: 24px; font-weight: 700; line-height: 1.35; color: #FFFFFF; margin: 0; letter-spacing: -0.01em; }
.lp-dif-right { display: flex; flex-direction: column; gap: 14px; }
.lp-dif-item { display: flex; align-items: flex-start; gap: 10px; font-size: 14px; color: rgba(255,255,255,0.72); line-height: 1.4; }
.lp-dif-item svg { flex-shrink: 0; margin-top: 1px; }

/* --- MÉTRICAS --- */
.lp-metricas { border-top: 1px solid rgba(255,255,255,0.06); padding: 96px 28px; }
.lp-met-h2 { font-size: 38px; font-weight: 800; line-height: 1.18; letter-spacing: -0.025em; color: #FFFFFF; margin: 0 0 48px; }
.lp-met-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
.lp-met-card {
  display: flex; flex-direction: column; gap: 14px;
  padding: 20px 18px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 10px;
  font-size: 14px; color: rgba(255,255,255,0.75);
  transition: background 0.15s;
}
.lp-met-card:hover { background: rgba(255,255,255,0.06); }
.lp-met-icon { width: 36px; height: 36px; background: rgba(255,119,28,0.1); border: 1px solid rgba(255,119,28,0.18); border-radius: 8px; display: flex; align-items: center; justify-content: center; }

/* --- ADOÇÃO DE IA --- */
.lp-ia { border-top: 1px solid rgba(255,255,255,0.06); padding: 0 28px 96px; }
.lp-ia-inner {
  max-width: 1000px; margin: 0 auto;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 20px;
  padding: 52px 56px;
  margin-top: -1px;
}
.lp-ia-top { margin-bottom: 40px; }
.lp-ia-h2 { font-size: 36px; font-weight: 800; line-height: 1.18; letter-spacing: -0.025em; color: #FFFFFF; margin: 16px 0 16px; }
.lp-ia-muted { color: rgba(255,255,255,0.38); }
.lp-ia-sub { font-size: 15px; line-height: 1.7; color: rgba(255,255,255,0.52); margin: 0; max-width: 720px; }
.lp-ia-kpis { display: grid; grid-template-columns: repeat(4,1fr); gap: 10px; margin-bottom: 36px; }
.lp-ia-kpi { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 20px 18px; }
.lp-ia-kpi-val { font-size: 28px; font-weight: 800; color: #FF771C; letter-spacing: -0.02em; margin-bottom: 6px; }
.lp-ia-kpi-label { font-size: 13px; line-height: 1.45; color: rgba(255,255,255,0.5); }
.lp-ia-feats-label { font-size: 13px; color: rgba(255,255,255,0.45); margin-bottom: 14px; }
.lp-ia-feats { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 32px; }
.lp-ia-feat { display: flex; gap: 14px; align-items: flex-start; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.07); border-radius: 10px; padding: 18px 16px; }
.lp-ia-feat-icon { width: 42px; height: 42px; background: rgba(255,119,28,0.1); border: 1px solid rgba(255,119,28,0.18); border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.lp-ia-feat-title { font-size: 15px; font-weight: 700; color: #FFFFFF; margin: 0 0 6px; }
.lp-ia-feat-desc { font-size: 13px; line-height: 1.55; color: rgba(255,255,255,0.5); margin: 0; }
.lp-ia-tools { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; padding-top: 8px; }
.lp-ia-tools-label { font-size: 13px; color: rgba(255,255,255,0.4); white-space: nowrap; }
.lp-ia-tools-list { display: flex; gap: 8px; flex-wrap: wrap; }
.lp-ia-tool { font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.7); background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); border-radius: 6px; padding: 5px 12px; }

/* --- PARA QUEM --- */
.lp-paraquem { border-top: 1px solid rgba(255,255,255,0.06); padding: 96px 28px; }
.lp-pq-inner { max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; }
.lp-pq-img-wrap { border-radius: 16px; overflow: hidden; aspect-ratio: 4/3; }
.lp-pq-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.lp-pq-content { display: flex; flex-direction: column; gap: 24px; }
.lp-pq-h2 { font-size: 38px; font-weight: 800; line-height: 1.18; letter-spacing: -0.025em; color: #FFFFFF; margin: 0; }
.lp-pq-tags { display: flex; flex-wrap: wrap; gap: 8px; }
.lp-pq-tag { font-size: 14px; color: rgba(255,255,255,0.7); background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12); border-radius: 7px; padding: 7px 14px; }

/* --- RESPONSIVE ADDITIONS --- */
@media (max-width: 960px) {
  .lp-met-grid { grid-template-columns: repeat(2, 1fr); }
  .lp-ia-kpis { grid-template-columns: 1fr 1fr; }
  .lp-ia-feats { grid-template-columns: 1fr; }
  .lp-pq-inner { grid-template-columns: 1fr; }
  .lp-ia-inner { padding: 32px 24px; }
}
@media (max-width: 600px) {
  .lp-met-grid { grid-template-columns: 1fr; }
  .lp-ia-kpis { grid-template-columns: 1fr; }
  .lp-metricas, .lp-ia, .lp-paraquem { padding: 60px 16px; }
  .lp-met-h2, .lp-ia-h2, .lp-pq-h2 { font-size: 26px; }
}

/* --- CTA FINAL --- */
.lp-cta-final { border-top: 1px solid rgba(255,255,255,0.06); padding: 120px 28px; text-align: center; }
.lp-cta-final-inner { max-width: 780px; margin: 0 auto; display: flex; flex-direction: column; align-items: center; gap: 24px; }
.lp-cta-final-h2 { font-size: 48px; font-weight: 800; line-height: 1.12; letter-spacing: -0.03em; color: #FFFFFF; margin: 0; }
.lp-cta-final-muted { color: rgba(255,255,255,0.35); }
.lp-cta-final-sub { font-size: 17px; line-height: 1.65; color: rgba(255,255,255,0.52); margin: 0; max-width: 620px; }
.lp-cta-final-btns { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; justify-content: center; margin-top: 8px; }
.lp-cta-vendas { font-size: 15px; font-weight: 500; color: rgba(255,255,255,0.7); background: transparent; border: 1px solid rgba(255,255,255,0.22); border-radius: 10px; padding: 14px 28px; cursor: pointer; transition: all 0.15s; }
.lp-cta-vendas:hover { border-color: rgba(255,255,255,0.5); color: #FFFFFF; }

/* --- FOOTER --- */
.lp-footer { border-top: 1px solid rgba(255,255,255,0.06); padding: 28px; text-align: center; }
.lp-footer-copy { font-size: 13px; color: rgba(255,255,255,0.28); }

@media (max-width: 600px) {
  .lp-cta-final { padding: 72px 16px; }
  .lp-cta-final-h2 { font-size: 28px; }
}

/* --- DARK OVERRIDES FOR LEGACY SECTIONS --- */
.ep-section { background: #0A0A0B !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.ep-badge { background: rgba(255,255,255,0.06) !important; border-color: rgba(255,255,255,0.1) !important; color: rgba(255,255,255,0.65) !important; }
.ep-main-title { color: #FFFFFF !important; }
.ep-orange { color: #FF771C !important; }
.ep-card { background: rgba(255,255,255,0.04) !important; border-color: rgba(255,255,255,0.08) !important; }
.ep-acc-label { color: #FF771C !important; }
.ep-acc-text, .ep-bloco-desc { color: rgba(255,255,255,0.6) !important; }
.ep-bloco-title { color: #FFFFFF !important; }
.ep-bloco-tag { color: #FF771C !important; }
.ep-oo-meeting, .ep-oo-title-row { color: rgba(255,255,255,0.75) !important; }
.ep-oo-text { color: rgba(255,255,255,0.6) !important; }
.ep-legend-item { color: rgba(255,255,255,0.55) !important; }
.ep-rm-label { color: rgba(255,255,255,0.38) !important; }
.ep-rm-value { color: #FFFFFF !important; }
.ep-radar-svg text { fill: rgba(255,255,255,0.55) !important; }
.cmp-section { background: #0A0A0B !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.cmp-title { color: #FFFFFF !important; }
.cmp-subtitle { color: rgba(255,255,255,0.55) !important; }
.cmp-th { background: rgba(255,255,255,0.04) !important; color: rgba(255,255,255,0.45) !important; border-color: rgba(255,255,255,0.07) !important; }
.cmp-th--elevment { background: rgba(255,119,28,0.12) !important; color: #FF771C !important; }
.cmp-td { border-color: rgba(255,255,255,0.05) !important; color: rgba(255,255,255,0.65) !important; background: transparent !important; }
.cmp-td--feat { color: rgba(255,255,255,0.8) !important; }
.cmp-icon--no { color: rgba(255,255,255,0.18) !important; }
.cmp-cta-strip { background: rgba(255,255,255,0.04) !important; border: 1px solid rgba(255,255,255,0.08) !important; }
.cmp-cta-title { color: #FFFFFF !important; }
.mod-perfis-section, .mod-interlude-section, .mod-catalogo-section, .mod-integ-section { background: #0A0A0B !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.mod-badge { background: rgba(255,255,255,0.06) !important; border-color: rgba(255,255,255,0.1) !important; color: rgba(255,255,255,0.65) !important; }
.mod-perfis-title, .mod-interlude-title, .mod-catalogo-title { color: #FFFFFF !important; }
.mod-manager-desc, .mod-role-desc, .mod-interlude-desc, .mod-catalogo-sub, .mod-integ-desc { color: rgba(255,255,255,0.52) !important; }
.mod-manager-card, .mod-role-card { background: rgba(255,255,255,0.04) !important; border: 1px solid rgba(255,255,255,0.08) !important; box-shadow: none !important; }
.mod-manager-title, .mod-role-title, .mod-integ-title { color: #FFFFFF !important; }
.mod-manager-metrics { background: rgba(255,255,255,0.025) !important; }
.mod-mm-tile, .mod-mm-panel { background: rgba(255,255,255,0.05) !important; box-shadow: none !important; }
.mod-mm-label, .mod-mm-sub, .mod-mm-vel-sub { color: rgba(255,255,255,0.38) !important; }
.mod-mm-value, .mod-mm-panel-title { color: #FFFFFF !important; }
.mod-mm-acao-lbl { color: rgba(255,255,255,0.65) !important; }
.mod-mm-bar { background: rgba(255,255,255,0.1) !important; }
.mod-mm-acao { border-bottom-color: rgba(255,255,255,0.05) !important; }
.mod-mm-leg-lbl { color: rgba(255,255,255,0.38) !important; }
.mod-catalogo-grid { background: rgba(255,255,255,0.04) !important; border: 1px solid rgba(255,255,255,0.07) !important; box-shadow: none !important; }
.mod-cat-card { border-color: rgba(255,255,255,0.06) !important; }
.mod-cat-card:hover { background: rgba(255,255,255,0.03) !important; }
.mod-cat-title { color: #FFFFFF !important; }
.mod-cat-desc { color: rgba(255,255,255,0.48) !important; }
.mod-integ-card { background: rgba(255,255,255,0.05) !important; border-color: rgba(255,255,255,0.1) !important; }
.mod-integ-name { color: rgba(255,255,255,0.75) !important; }
.mod-integ-quote { background: rgba(255,255,255,0.03) !important; border-color: rgba(255,119,28,0.25) !important; }
.mod-integ-quote-text { color: rgba(255,255,255,0.62) !important; }
.mod-integ-quote-author { color: rgba(255,119,28,0.75) !important; }
.sec-seguranca { background: #0A0A0B !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.seg-title { color: #FFFFFF !important; }
.seg-pill { background: rgba(255,255,255,0.05) !important; border-color: rgba(255,255,255,0.1) !important; color: rgba(255,255,255,0.65) !important; }
.seg-banner-section { background: #0F0F11 !important; }
.seg-banner-title { color: #FFFFFF !important; }
.seg-banner-orange { color: #FF771C !important; }
.seg-banner-label, .seg-banner-desc { color: rgba(255,255,255,0.45) !important; }
.demo-cta-section { background: #0A0A0B !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.demo-cta-title { color: #FFFFFF !important; }
.demo-cta-desc { color: rgba(255,255,255,0.52) !important; }
.new-footer { background: #060608 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.footer-copy-new, .footer-locale, .footer-partners-label { color: rgba(255,255,255,0.32) !important; }

/* --- RESPONSIVE --- */
@media (max-width: 960px) {
  .lp-nav-links, .lp-nav-right { display: none; }
  .lp-hamburger { display: block; }
  .lp-hero-h1 { font-size: 42px; }
  .lp-hero-mock-wrap { max-width: 100%; }
  .lp-prob-grid { grid-template-columns: 1fr; }
  .lp-como-steps { grid-template-columns: 1fr; }
  .lp-dif-card { grid-template-columns: 1fr; gap: 24px; padding: 28px 24px; }
}
@media (max-width: 600px) {
  .lp-hero { padding: 100px 16px 0; }
  .lp-hero-h1 { font-size: 30px; }
  .lp-problema, .lp-como { padding: 60px 16px; }
  .lp-problema-h2, .lp-como-h2 { font-size: 26px; }
  .lp-dif-card { padding: 20px 18px; }
}

/* ============================================================
   LEGACY BASE (kept for backward-compat of old sections)
============================================================ */
/* ============ RESET & BASE ============ */
* {
  box-sizing: border-box;
}

.landing-page {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #1D1D1F;
  background: #FAFAFA;
  -webkit-font-smoothing: antialiased;
}

/* ============ NAVBAR ============ */
.landing-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #F0F0F0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
}

.nav-logo {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  cursor: pointer;
}

.nav-logo-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #2D2D2D;
  color: #FF771C;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 800;
  margin-right: 3px;
}

.nav-logo-elev {
  color: #FF771C;
}

.nav-logo-ment {
  color: #1D1D1F;
}

.nav-links {
  display: flex;
  gap: 32px;
}

.nav-link {
  color: #6B6B6B;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
}

.nav-link:hover {
  color: #1D1D1F;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.nav-login {
  color: #1D1D1F;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s;
}

.nav-login:hover {
  color: #FF771C;
}

.nav-demo-btn {
  display: inline-flex;
  align-items: center;
  background: #FF771C;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-demo-btn:hover {
  background: #E8691A;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 119, 28, 0.3);
}

.nav-mobile-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.nav-mobile-menu {
  display: none;
  padding: 16px 32px 24px;
  border-top: 1px solid #F0F0F0;
}

.nav-mobile-link {
  display: block;
  padding: 12px 0;
  color: #6B6B6B;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  border-bottom: 1px solid #F5F5F5;
}

.nav-mobile-link--consultoria {
  color: #FF771C;
  font-weight: 600;
  cursor: pointer;
}

.nav-mobile-actions {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nav-mobile-login {
  text-align: center;
  color: #1D1D1F;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  padding: 10px;
}

.nav-demo-btn--full {
  width: 100%;
  justify-content: center;
}

@media (max-width: 768px) {
  .nav-links,
  .nav-actions {
    display: none;
  }

  .nav-mobile-btn {
    display: block;
  }

  .nav-mobile-menu {
    display: block;
  }
}

/* ============ HERO ============ */
.hero-section {
  padding-top: 120px;
  padding-bottom: 80px;
  background: #FAFAFA;
  overflow: hidden;
}

.hero-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 48px;
  align-items: center;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #FFF3EB;
  color: #FF771C;
  border: 1px solid #FFD9BD;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 28px;
}

.hero-badge-icon {
  font-size: 14px;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.03em;
  color: #1D1D1F;
  margin-bottom: 24px;
}

.hero-title-highlight {
  color: #FF771C;
}

.hero-description {
  font-size: 16px;
  line-height: 1.65;
  color: #6B6B6B;
  margin-bottom: 16px;
  max-width: 480px;
}

.hero-ctas {
  display: flex;
  gap: 12px;
  margin-top: 32px;
}

.hero-btn-primary {
  display: inline-flex;
  align-items: center;
  background: #FF771C;
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.hero-btn-primary:hover {
  background: #E8691A;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 119, 28, 0.35);
}

.hero-btn-secondary {
  background: white;
  color: #1D1D1F;
  border: 1px solid #E0E0E0;
  padding: 14px 28px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.hero-btn-secondary:hover {
  border-color: #FF771C;
  color: #FF771C;
  transform: translateY(-1px);
}

/* Hero Responsive */
@media (max-width: 960px) {
  .hero-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .hero-content {
    order: 1;
  }

  .hero-preview {
    order: 2;
  }

  .hero-title {
    font-size: 38px;
  }

  .hero-description {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding-top: 100px;
    padding-bottom: 60px;
  }

  .hero-container {
    padding: 0 20px;
    gap: 32px;
  }

  .hero-title {
    font-size: 32px;
  }

  .hero-description {
    font-size: 15px;
  }

  .hero-ctas {
    flex-direction: column;
    gap: 12px;
  }

  .hero-btn-primary,
  .hero-btn-secondary {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-badge {
    font-size: 11px;
    padding: 4px 12px;
  }
}

/* ============ HERO CARD & NEW HERO CLASSES ============ */
.hero-badge-pill {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #FF771C;
  margin-bottom: 24px;
}
.hero-title-gray { color: #86868B; }
.hero-title-orange { color: #FF771C; }

.hero-preview {
  position: relative;
}
.hero-card {
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 4px 32px rgba(0,0,0,0.10);
  padding: 16px;
  width: 100%;
}
.hero-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hero-card-sync {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #86868B;
}
.hero-sync-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #34C759;
  flex-shrink: 0;
}
.hero-card-toggle {
  display: flex;
  gap: 3px;
  background: #F5F5F7;
  border-radius: 8px;
  padding: 3px;
}
.hero-toggle-btn {
  font-size: 11px;
  font-weight: 500;
  color: #86868B;
  padding: 3px 10px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}
.hero-toggle-btn.active {
  background: #FFFFFF;
  color: #1D1D1F;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}
.hero-metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
}
.hero-metric-tile {
  background: #FAFAFA;
  border-radius: 10px;
  padding: 10px 12px;
}
.hmt-label {
  font-size: 9px;
  color: #86868B;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 2px;
}
.hmt-value {
  font-size: 20px;
  font-weight: 700;
  color: #1D1D1F;
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin-bottom: 5px;
}
.hmt-slash {
  font-size: 12px;
  font-weight: 400;
  color: #aaa;
}
.hmt-bar {
  height: 3px;
  border-radius: 2px;
  background: #E5E5EA;
  margin-bottom: 4px;
}
.hmt-bar-fill {
  height: 100%;
  border-radius: 2px;
}
.hmt-bar-fill.orange { background: #FF771C; }
.hmt-bar-fill.green  { background: #34C759; }
.hmt-bar-fill.blue   { background: #007AFF; }
.hmt-bar-fill.yellow { background: #FFD60A; }
.hmt-trend {
  font-size: 10px;
  color: #86868B;
}
.hmt-trend .pos { color: #34C759; font-weight: 600; }
/* Métricas Favoritas header */
.hero-mf-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
}
.hero-mf-title {
  font-size: 12px;
  font-weight: 700;
  color: #1D1D1F;
}
.hero-mf-sub {
  font-size: 10px;
  color: #86868B;
}
.hero-mf-btn {
  font-size: 10px;
  font-weight: 600;
  color: #FF771C;
  background: #FFF3EB;
  border-radius: 6px;
  padding: 4px 8px;
  white-space: nowrap;
  cursor: pointer;
}
/* Source badges */
.hero-source-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  border-radius: 4px;
  padding: 2px 8px;
  margin-bottom: 6px;
}
.hero-source-badge.github { background: #1D1D1F; color: #FFFFFF; }
.hero-source-badge.jira { background: #0052CC; color: #FFFFFF; }
/* Chart cards */
.hero-charts-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
}
.hero-chart-card {
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 10px;
  padding: 10px 10px 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}
.hero-chart-title {
  font-size: 11px;
  font-weight: 700;
  color: #1D1D1F;
  line-height: 1.3;
}
.hero-chart-sub {
  font-size: 9px;
  color: #86868B;
  margin-bottom: 2px;
}
.hero-svg-chart {
  width: 100%;
  height: 64px;
  overflow: visible;
}
.hero-chart-legend {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 9px;
  color: #86868B;
  flex-wrap: wrap;
}
.hero-legend-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
/* Velocity list */
.hero-velocity-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 2px;
}
.hero-vel-avg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFF3EB;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 10px;
  color: #86868B;
}
.hero-vel-pct {
  font-weight: 700;
  color: #FF771C;
  font-size: 12px;
}
.hero-vel-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.hero-vel-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 7px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
  margin-top: 1px;
}
.hero-vel-info { flex: 1; min-width: 0; }
.hero-vel-name {
  font-size: 10px;
  font-weight: 600;
  color: #1D1D1F;
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
}
.hero-vel-num {
  color: #86868B;
  font-weight: 500;
}
.hero-vel-bar {
  height: 3px;
  background: #F0F0F0;
  border-radius: 2px;
  margin-bottom: 2px;
  overflow: hidden;
}
.hero-vel-fill {
  height: 100%;
  border-radius: 2px;
}
.hero-vel-meta {
  font-size: 9px;
  color: #aaa;
}
/* Hero Responsive */
@media (max-width: 960px) {
  .hero-preview { order: -1; }
  .hero-card { max-width: 100%; }
}
@media (max-width: 600px) {
  .hero-card { padding: 12px; }
  .hero-metrics-grid { gap: 6px; }
  .hmt-value { font-size: 16px; }
  .hero-charts-row { grid-template-columns: 1fr; }
}

/* ============ PLACEHOLDER SECTIONS ============ */
.section-placeholder {
  min-height: 0;
}

/* ============ STATS BAR ============ */
.stats-section {
  background: #FAFAFA;
  padding: 48px 0 56px;
  border-top: 1px solid #F0F0F0;
  border-bottom: 1px solid #F0F0F0;
}

.stats-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  text-align: center;
}

@media (max-width: 768px) {
  .stats-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    padding: 0 24px;
  }
  .stat-value {
    font-size: 36px;
  }
  .stat-pct {
    font-size: 22px;
  }
}

@media (max-width: 400px) {
  .stats-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

.stat-value {
  font-size: 44px;
  font-weight: 700;
  color: #FF771C;
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin-bottom: 6px;
}

.stat-pct {
  font-size: 28px;
  font-weight: 700;
  color: #FF771C;
}

.stat-label {
  font-size: 14px;
  color: #86868B;
  font-weight: 500;
}

/* ============ PROBLEMA SECTION (NEW) ============ */
.problema-section {
  background: #F8F6F3;
  padding: 96px 0;
}
.problema-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 32px;
}
.problema-badge-row {
  margin-bottom: 40px;
}
.problema-badge {
  display: inline-block;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 100px;
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #444;
  letter-spacing: 0.02em;
}
.problema-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  margin-bottom: 56px;
}
.problema-col-text {
  font-size: 17px;
  line-height: 1.7;
  color: #444;
  margin: 0;
}
.problema-quote {
  border-top: 1px solid #E5E5EA;
  padding-top: 48px;
  margin-bottom: 40px;
}
.problema-quote p {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: #1D1D1F;
  margin: 0;
}
.problema-quote-orange {
  color: #FF771C;
}
.problema-cta {
  display: flex;
  align-items: center;
  gap: 20px;
}
.problema-cta-btn {
  background: #FF771C;
  color: #FFFFFF;
  border: none;
  border-radius: 10px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.problema-cta-btn:hover {
  background: #E05F00;
}
.problema-cta-sub {
  font-size: 14px;
  color: #86868B;
}

/* Problema responsive */
@media (max-width: 768px) {
  .problema-cols {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .problema-quote p {
    font-size: 24px;
  }
}
@media (max-width: 480px) {
  .problema-section { padding: 64px 0; }
  .problema-container { padding: 0 20px; }
  .problema-quote p { font-size: 20px; }
  .problema-cta { flex-direction: column; align-items: flex-start; }
}

/* ============ DIA A DIA SECTION ============ */
.diadia-section {
  background: #FFFFFF;
  padding: 96px 0;
}
.diadia-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}
.diadia-image {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  aspect-ratio: 4/3;
}
.diadia-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
.diadia-img-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 280px;
  background: #F5F3EF;
}
.diadia-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #FF771C;
  margin-bottom: 16px;
}
.diadia-title {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #1D1D1F;
  margin-bottom: 20px;
}
.diadia-desc {
  font-size: 17px;
  line-height: 1.7;
  color: #86868B;
  margin: 0;
}

/* Dia a Dia responsive */
@media (max-width: 960px) {
  .diadia-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .diadia-title { font-size: 28px; }
}
@media (max-width: 480px) {
  .diadia-section { padding: 64px 0; }
  .diadia-container { padding: 0 20px; }
  .diadia-title { font-size: 24px; }
}

/* ============ ENGENHARIA × PESSOAS SECTION ============ */
.ep-section {
  background: #F8F6F3;
  padding: 96px 0 80px;
}

.ep-header {
  max-width: 1100px;
  margin: 0 auto 72px;
  padding: 0 32px;
}

.ep-badge {
  display: inline-block;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 100px;
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #444;
  letter-spacing: 0.02em;
  margin-bottom: 28px;
}

.ep-main-title {
  font-size: 52px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #1D1D1F;
  max-width: 700px;
}

.ep-orange { color: #FF771C; }

/* Blocks */
.ep-block {
  max-width: 1100px;
  margin: 0 auto 80px;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}

.ep-left { display: flex; flex-direction: column; }

.ep-card {
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  overflow: hidden;
}

/* Accordion card (Block A) */
.ep-card--accordion {
  padding: 8px 0;
}

.ep-acc-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 24px;
}

.ep-acc-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ep-acc-body { flex: 1; }

.ep-acc-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #FF771C;
  margin-bottom: 6px;
}

.ep-acc-text {
  font-size: 14px;
  color: #444;
  line-height: 1.6;
  margin: 0;
}

.ep-acc-highlight { color: #FF771C; font-weight: 600; }

.ep-acc-arrow {
  text-align: center;
  font-size: 16px;
  color: #BBBBBB;
  padding: 2px 0;
}

/* 1:1 card (Block B) */
.ep-card--oneonone {
  padding: 0;
}

.ep-oo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #F0F0F0;
}

.ep-oo-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ep-oo-meeting {
  font-size: 14px;
  font-weight: 600;
  color: #1D1D1F;
}

.ep-oo-ai-pill {
  font-size: 11px;
  font-weight: 600;
  color: #FF771C;
  background: #FFF3EB;
  border: 1px solid #FFD9BA;
  border-radius: 100px;
  padding: 3px 10px;
  white-space: nowrap;
}

.ep-oo-items { padding: 4px 0; }

.ep-oo-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-bottom: 1px solid #F5F5F7;
  transition: background 0.15s;
}

.ep-oo-item:last-child { border-bottom: none; }
.ep-oo-item:hover { background: #FAFAFA; }

.ep-oo-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  border-radius: 4px;
  padding: 3px 7px;
  flex-shrink: 0;
}

.ep-oo-badge--risco { background: #FFE5E5; color: #D32F2F; }
.ep-oo-badge--atencao { background: #FFF8E1; color: #F57F17; }
.ep-oo-badge--atrasado { background: #FFF3EB; color: #E65100; }
.ep-oo-badge--lembrete { background: #E8F4FD; color: #1565C0; }

.ep-oo-text { font-size: 13px; color: #444; flex: 1; line-height: 1.5; }

.ep-oo-chevron { font-size: 18px; color: #CCCCCC; margin-left: 4px; }

/* Radar card (Block C) */
.ep-card--radar { padding: 24px; }

.ep-radar-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.ep-radar-svg { width: 100%; max-width: 320px; }

.ep-radar-legend {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 20px;
}

.ep-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #666;
}

.ep-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.ep-legend-dot--gray { background: #BBBBBB; }
.ep-legend-dot--orange { background: #FF771C; }

.ep-radar-metrics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.ep-rm-tile {
  background: #FAFAFA;
  border-radius: 10px;
  padding: 12px;
  border: 1px solid #F0F0F0;
}

.ep-rm-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #999;
  margin-bottom: 6px;
}

.ep-rm-row { display: flex; align-items: baseline; gap: 6px; }

.ep-rm-value {
  font-size: 22px;
  font-weight: 700;
  color: #1D1D1F;
  letter-spacing: -0.02em;
}

.ep-rm-delta {
  font-size: 12px;
  font-weight: 600;
}

.ep-rm-delta--pos { color: #34C759; }
.ep-rm-delta--neg { color: #D32F2F; }

/* Right side */
.ep-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ep-bloco-tag {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #999;
  margin-bottom: 16px;
}

.ep-bloco-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #1D1D1F;
  margin-bottom: 16px;
}

.ep-bloco-desc {
  font-size: 16px;
  line-height: 1.75;
  color: #86868B;
  margin: 0;
}

/* Responsive */
@media (max-width: 960px) {
  .ep-main-title { font-size: 36px; }
  .ep-block {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .ep-bloco-title { font-size: 26px; }
  .ep-radar-metrics { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 600px) {
  .ep-section { padding: 64px 0 48px; }
  .ep-header { margin-bottom: 48px; padding: 0 20px; }
  .ep-block { padding: 0 20px; margin-bottom: 56px; }
  .ep-main-title { font-size: 28px; }
  .ep-bloco-title { font-size: 22px; }
  .ep-radar-metrics { grid-template-columns: repeat(2, 1fr); gap: 8px; }
  .ep-rm-value { font-size: 20px; }
  .ep-rm-label { font-size: 10px; }
  .ep-rm-tile { padding: 10px; }
}

/* ============ COMPARATIVO SECTION ============ */
.cmp-section {
  background: #F8F6F3;
  padding: 96px 0 80px;
}

.cmp-header {
  max-width: 1100px;
  margin: 0 auto 48px;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: flex-end;
}

.cmp-badge {
  display: inline-block;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 100px;
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #444;
  letter-spacing: 0.02em;
  margin-bottom: 28px;
}

.cmp-title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #1D1D1F;
  margin: 0;
}

.cmp-subtitle {
  font-size: 16px;
  line-height: 1.7;
  color: #86868B;
  margin: 0;
  padding-bottom: 6px;
}

.cmp-table-wrap {
  max-width: 1100px;
  margin: 0 auto 40px;
  padding: 0 32px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.cmp-table {
  width: 100%;
  border-collapse: collapse;
  background: #FFFFFF;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
}

.cmp-th {
  padding: 18px 20px;
  font-size: 13px;
  font-weight: 600;
  color: #86868B;
  text-align: center;
  background: #FFFFFF;
  border-bottom: 1px solid #F0F0F0;
}

.cmp-th--cap {
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #BBBBBB;
}

.cmp-th--elevment {
  color: #FF771C;
  font-weight: 700;
}

.cmp-row {
  border-bottom: 1px solid #F5F5F7;
  transition: background 0.12s;
}

.cmp-row:last-child { border-bottom: none; }
.cmp-row:hover { background: #FAFAFA; }

.cmp-td {
  padding: 16px 20px;
  text-align: center;
  font-size: 14px;
  color: #444;
  vertical-align: middle;
}

.cmp-td--feat {
  text-align: left;
  font-size: 14px;
  color: #1D1D1F;
  font-weight: 400;
  min-width: 200px;
}

.cmp-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cmp-icon--no {
  font-size: 16px;
  color: #CCCCCC;
  font-style: normal;
}

.cmp-icon--yes {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #FF771C;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cmp-icon--yes svg {
  width: 14px;
  height: 14px;
}

.cmp-icon--yes-green {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #E8F8EE;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cmp-icon--yes-green svg {
  width: 14px;
  height: 14px;
}

.cmp-icon--partial {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cmp-icon--partial svg {
  width: 22px;
  height: 22px;
}

/* Bottom CTA strip */
.cmp-cta-strip {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 32px 40px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.cmp-cta-left { display: flex; flex-direction: column; gap: 6px; }

.cmp-cta-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #FF771C;
}

.cmp-cta-title {
  font-size: 22px;
  font-weight: 700;
  color: #1D1D1F;
  margin: 0;
  letter-spacing: -0.01em;
}

.cmp-cta-btn {
  background: #FF771C;
  color: #FFFFFF;
  border: none;
  border-radius: 10px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.cmp-cta-btn:hover { background: #E05F00; }

/* ============ MÓDULOS: PERFIS ============ */
.mod-perfis-section {
  background: #F8F6F3;
  padding: 96px 0 80px;
}
.mod-perfis-header {
  max-width: 1100px;
  margin: 0 auto 32px;
  padding: 0 32px;
}
.mod-badge {
  display: inline-block;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 100px;
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #444;
  letter-spacing: 0.02em;
  margin-bottom: 24px;
}
.mod-perfis-title {
  font-size: 52px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #1D1D1F;
  margin: 0;
}
.mod-perfis-top-row {
  max-width: 1100px;
  margin: 0 auto 20px;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 20px;
  align-items: start;
}
.mod-roles-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.mod-manager-card {
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.mod-role-card {
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mod-manager-top { display: flex; flex-direction: column; gap: 12px; }

/* Manager dashboard mock */
.mgr-dash {
  background: #F8F6F3;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mgr-filterbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.mgr-filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.mgr-filter-chip {
  background: #fff;
  border: 1px solid #E5E5EA;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.mgr-filter-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.mgr-btn-apply {
  background: #FF771C;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.mgr-btn-clear {
  background: #fff;
  border: 1px solid #E5E5EA;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  color: #86868B;
  cursor: pointer;
}
.mgr-view-toggle {
  display: flex;
  background: #fff;
  border: 1px solid #E5E5EA;
  border-radius: 6px;
  overflow: hidden;
  font-size: 11px;
}
.mgr-toggle-active {
  background: #FF771C;
  color: #fff;
  padding: 4px 10px;
  font-weight: 600;
}
.mgr-toggle-inactive {
  color: #86868B;
  padding: 4px 10px;
}
.mgr-kpi-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}
.mgr-kpi-tile {
  background: #fff;
  border-radius: 8px;
  padding: 10px 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.mgr-kpi-tile--highlight {
  box-shadow: 0 2px 10px rgba(231,76,60,0.15);
}
.mgr-kpi-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.mgr-kpi-label {
  font-size: 10px;
  color: #86868B;
  line-height: 1.3;
  max-width: 70px;
}
.mgr-kpi-icon {
  width: 24px; height: 24px;
  border-radius: 6px;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mgr-kpi-val {
  font-size: 22px;
  font-weight: 800;
  color: #1D1D1F;
  line-height: 1;
}
.mgr-kpi-sub {
  font-size: 9px;
  color: #86868B;
}
.mgr-bottom-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.mgr-acoes, .mgr-velocidade {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mgr-section-title {
  font-size: 12px;
  font-weight: 700;
  color: #1D1D1F;
}
.mgr-vel-sub {
  font-size: 10px;
  color: #86868B;
  margin-top: -4px;
}
.mgr-acao-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #F0F0F0;
}
.mgr-acao-item:last-child { border-bottom: none; }
.mgr-acao-icon {
  width: 24px; height: 24px;
  border-radius: 6px;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mgr-acao-label {
  flex: 1;
  font-size: 11px;
  color: #1D1D1F;
}
.mgr-acao-badge {
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 100px;
  padding: 2px 8px;
  min-width: 22px;
  text-align: center;
}
.mgr-chart { display: flex; flex-direction: column; gap: 4px; }
.mgr-vel-legend {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 9px;
  color: #86868B;
}
.mgr-leg-dot {
  width: 8px; height: 8px;
  border-radius: 2px;
  display: inline-block;
}
.mgr-leg-label { margin-right: 4px; }
.mod-manager-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.mod-role-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 4px;
}
.mod-manager-title {
  font-size: 26px;
  font-weight: 700;
  color: #1D1D1F;
  margin: 0;
}
.mod-mais-usado {
  display: inline-block;
  background: #FF771C;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 600;
  border-radius: 100px;
  padding: 5px 14px;
  white-space: nowrap;
  flex-shrink: 0;
  margin-top: 4px;
}
.mod-manager-desc {
  font-size: 15px;
  line-height: 1.65;
  color: #86868B;
  margin: 0;
}
.mod-manager-metrics {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #F8F6F3;
  border-radius: 12px;
  padding: 16px;
}
.mod-mm-kpi-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}
.mod-mm-tile {
  background: #fff;
  border-radius: 10px;
  padding: 10px 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.mod-mm-tile--alert { box-shadow: 0 2px 8px rgba(231,76,60,0.12); }
.mod-mm-tile-top {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}
.mod-mm-icon {
  width: 26px; height: 26px;
  border-radius: 7px;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mod-mm-label {
  font-size: 10px;
  color: #86868B;
  line-height: 1.3;
  flex: 1;
}
.mod-mm-value {
  font-size: 24px;
  font-weight: 800;
  color: #1D1D1F;
  line-height: 1;
}
.mod-mm-sub {
  font-size: 9px;
  color: #86868B;
}
.mod-mm-bottom-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.mod-mm-panel {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.mod-mm-panel-title {
  font-size: 12px;
  font-weight: 700;
  color: #1D1D1F;
}
.mod-mm-vel-sub {
  font-size: 10px;
  color: #86868B;
  margin-top: -2px;
}
.mod-mm-acao {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid #F5F5F5;
}
.mod-mm-acao:last-child { border-bottom: none; }
.mod-mm-acao-lbl {
  flex: 1;
  font-size: 11px;
  color: #1D1D1F;
}
.mod-mm-badge {
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 100px;
  padding: 2px 7px;
  min-width: 20px;
  text-align: center;
}
.mod-mm-bar {
  height: 4px;
  background: #E5E5EA;
  border-radius: 2px;
  overflow: hidden;
}
.mod-mm-fill {
  height: 100%;
  background: #FF771C;
  border-radius: 2px;
}
.mod-mm-vel-legend {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
}
.mod-mm-leg-dot {
  width: 8px; height: 8px;
  border-radius: 2px;
  display: inline-block;
  flex-shrink: 0;
}
.mod-mm-leg-lbl {
  font-size: 10px;
  color: #86868B;
  margin-right: 4px;
}
.mod-mm-tile { display: flex; flex-direction: column; gap: 6px; }
.mod-mm-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #999;
  text-transform: uppercase;
}
.mod-mm-value {
  font-size: 32px;
  font-weight: 700;
  color: #1D1D1F;
  letter-spacing: -0.02em;
  line-height: 1;
}
.mod-mm-bar {
  height: 4px;
  background: #E5E5EA;
  border-radius: 2px;
  overflow: hidden;
}
.mod-mm-fill {
  height: 100%;
  background: #FF771C;
  border-radius: 2px;
}
.mod-roles-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.mod-role-title {
  font-size: 20px;
  font-weight: 700;
  color: #1D1D1F;
  margin: 0;
}
.mod-role-desc {
  font-size: 13px;
  line-height: 1.6;
  color: #86868B;
  margin: 0;
}

/* ============ MÓDULOS: INTERLUDE ============ */
.mod-interlude-section {
  background: #FFFFFF;
  padding: 96px 0;
  border-top: 1px solid #F0F0F0;
  border-bottom: 1px solid #F0F0F0;
}
.mod-interlude-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
.mod-interlude-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #FF771C;
  margin-bottom: 16px;
}
.mod-interlude-title {
  font-size: 40px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #1D1D1F;
  margin-bottom: 20px;
}
.mod-interlude-desc {
  font-size: 16px;
  line-height: 1.75;
  color: #86868B;
  margin: 0;
}
.mod-interlude-image {
  border-radius: 20px;
  aspect-ratio: 4/3;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  min-height: 320px;
}
.mod-interlude-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
.mod-interlude-img-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* ============ MÓDULOS: CATÁLOGO ============ */
.mod-catalogo-section {
  background: #F8F6F3;
  padding: 96px 0 72px;
}
.mod-catalogo-header {
  max-width: 1100px;
  margin: 0 auto 48px;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: flex-end;
}
.mod-catalogo-title {
  font-size: 52px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.03em;
  color: #1D1D1F;
  margin: 8px 0 0;
}
.mod-catalogo-sub {
  font-size: 16px;
  line-height: 1.7;
  color: #86868B;
  margin: 0;
  padding-bottom: 6px;
}
.mod-catalogo-grid {
  max-width: 1100px;
  margin: 0 auto 48px;
  padding: 0 32px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
  overflow: hidden;
}
.mod-cat-card {
  padding: 28px 22px;
  border-right: 1px solid #F0F0F0;
  border-bottom: 1px solid #F0F0F0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: background 0.15s;
}
.mod-cat-card:hover { background: #FAFAFA; }
.mod-cat-card:nth-child(4n) { border-right: none; }
.mod-cat-card:nth-child(n+9) { border-bottom: none; }
.mod-cat-icon { color: #FF771C; }
.mod-cat-title {
  font-size: 15px;
  font-weight: 700;
  color: #1D1D1F;
  margin: 0;
  line-height: 1.3;
}
.mod-cat-desc {
  font-size: 13px;
  line-height: 1.6;
  color: #86868B;
  margin: 0;
}
.mod-catalogo-cta {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.mod-catalogo-cta-text {
  font-size: 16px;
  color: #86868B;
}
.mod-catalogo-cta-btn {
  background: #FF771C;
  color: #FFFFFF;
  border: none;
  border-radius: 10px;
  padding: 14px 28px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}
.mod-catalogo-cta-btn:hover { background: #E05F00; }

/* ============ MÓDULOS: INTEGRAÇÕES ============ */
.mod-integ-section {
  background: #F8F6F3;
  padding: 96px 0;
  border-top: 1px solid #EBEBEB;
}
.mod-integ-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 64px;
  align-items: center;
}
.mod-integ-title {
  font-size: 40px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #1D1D1F;
  margin: 8px 0 16px;
}
.mod-integ-desc {
  font-size: 15px;
  line-height: 1.7;
  color: #86868B;
  margin: 0 0 28px;
}
.mod-integ-quote {
  background: #FFFFFF;
  border-radius: 12px;
  border-left: 3px solid #FF771C;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.mod-integ-quote-text {
  font-size: 14px;
  line-height: 1.65;
  color: #444;
  margin: 0 0 10px;
  font-style: italic;
}
.mod-integ-quote-text strong { font-style: normal; color: #1D1D1F; font-weight: 700; }
.mod-integ-quote-author { font-size: 12px; color: #999; display: block; }
.mod-integ-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 12px;
}
.mod-integ-card {
  background: #FFFFFF;
  border-radius: 14px;
  border: 1px solid #E5E5EA;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  min-height: 90px;
  transition: box-shadow 0.15s;
  gap: 6px;
}
.mod-integ-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
.mod-integ-card--featured {
  grid-row: 1 / 3;
  border-color: #FF771C;
  border-width: 2px;
  min-height: 200px;
}
.mod-integ-name { font-size: 16px; font-weight: 700; color: #1D1D1F; }
.mod-integ-featured-label { font-size: 12px; color: #FF771C; font-weight: 500; }
.mod-integ-card--sm .mod-integ-name { font-size: 14px; }

/* Módulos responsive */
@media (max-width: 960px) {
  .mod-perfis-title, .mod-catalogo-title { font-size: 36px; }
  .mod-perfis-top-row { grid-template-columns: 1fr; }
  .mod-interlude-container { grid-template-columns: 1fr; gap: 40px; }
  .mod-interlude-title { font-size: 30px; }
  .mod-catalogo-header { grid-template-columns: 1fr; }
  .mod-catalogo-grid { grid-template-columns: repeat(2, 1fr); }
  .mod-cat-card:nth-child(4n) { border-right: 1px solid #F0F0F0; }
  .mod-cat-card:nth-child(2n) { border-right: none; }
  .mod-cat-card:nth-child(n+9) { border-bottom: 1px solid #F0F0F0; }
  .mod-cat-card:nth-child(n+11) { border-bottom: none; }
  .mod-integ-container { grid-template-columns: 1fr; gap: 40px; }
  .mod-integ-title { font-size: 30px; }
}
@media (max-width: 600px) {
  .mod-perfis-section, .mod-interlude-section, .mod-catalogo-section, .mod-integ-section { padding: 64px 0 48px; }
  .mod-perfis-header, .mod-perfis-top-row, .mod-interlude-container,
  .mod-catalogo-header, .mod-catalogo-grid, .mod-catalogo-cta, .mod-integ-container { padding: 0 20px; }
  .mod-perfis-title { font-size: 28px; }
  .mod-catalogo-title { font-size: 28px; }
  .mod-catalogo-cta { flex-direction: column; text-align: center; }
  .mod-integ-grid { grid-template-columns: 1fr 1fr; }
  .mod-integ-card--featured { grid-row: auto; }
}

/* Comparativo responsive */
@media (max-width: 960px) {
  .cmp-header {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .cmp-title { font-size: 36px; }
  .cmp-cta-strip { flex-direction: column; align-items: flex-start; }
}

@media (max-width: 768px) {
  .cmp-table-wrap { padding: 0 16px; }
  .cmp-cta-strip { margin: 0 16px; }
}

@media (max-width: 600px) {
  .cmp-section { padding: 64px 0 48px; }
  .cmp-header { padding: 0 20px; margin-bottom: 32px; }
  .cmp-table-wrap { padding: 0 16px; overflow-x: auto; -webkit-overflow-scrolling: touch; }
  .cmp-title { font-size: 28px; }
  .cmp-th, .cmp-td { padding: 10px 8px; }
  .cmp-td--feat { min-width: 130px; font-size: 12px; }
  .cmp-th { font-size: 10px; }
  .cmp-icon--yes, .cmp-icon--yes-green { width: 22px; height: 22px; }
  .cmp-icon--yes svg, .cmp-icon--yes-green svg { width: 11px; height: 11px; }
  .cmp-icon--partial svg { width: 18px; height: 18px; }
  .cmp-cta-strip { margin: 0 16px; padding: 20px; }
  .cmp-cta-title { font-size: 18px; }
}

/* ============ SEGURANÇA SECTION ============ */
.sec-seguranca {
  background: #F8F6F3;
  padding: 80px 0 64px;
}
.sec-seg-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
}
.seg-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 40px;
}
.seg-title {
  font-size: 52px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #1D1D1F;
  margin: 0;
}
.seg-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.seg-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 100px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #1D1D1F;
  white-space: nowrap;
}

/* Stats */
.seg-stats-section {
  background: #F8F6F3;
  padding: 64px 0;
  border-top: 1px solid #EBEBEB;
}
.seg-stats-inner {
  max-width: 1100px;
  margin: 0 auto 40px;
  padding: 0 32px;
  display: flex;
  align-items: flex-start;
  gap: 0;
}
.seg-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.seg-stat-divider {
  width: 1px;
  background: #E5E5EA;
  align-self: stretch;
  margin: 0 40px;
}
.seg-stat-num {
  font-size: 80px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: #1D1D1F;
  line-height: 1;
}

@media (max-width: 768px) {
  .seg-stats-inner {
    flex-direction: column;
    gap: 32px;
    padding: 0 24px;
  }
  .seg-stat-divider { display: none; }
  .seg-stat-num { font-size: 56px; }
}

@media (max-width: 480px) {
  .seg-stat-num { font-size: 44px; }
}
.seg-stat-label {
  font-size: 14px;
  line-height: 1.5;
  color: #86868B;
}
.seg-notice-bar {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
}
.seg-notice-bar p {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 18px 28px;
  font-size: 14px;
  line-height: 1.6;
  color: #86868B;
  margin: 0;
  border: 1px solid #EBEBEB;
}
.seg-notice-bar p strong {
  color: #1D1D1F;
  font-weight: 700;
}

/* Banner */
.seg-banner-section {
  position: relative;
  background: #1A1A1A url('') center/cover no-repeat;
  min-height: 480px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.seg-banner-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(26,26,26,0.85) 40%, rgba(26,26,26,0.3) 100%);
}
.seg-banner-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  margin: 0 auto;
  padding: 80px 32px;
  max-width: 640px;
  margin-left: clamp(32px, 8vw, 120px);
}
.seg-banner-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #FF771C;
  margin-bottom: 20px;
}
.seg-banner-title {
  font-size: 52px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.03em;
  color: #FFFFFF;
  margin: 0 0 24px;
}
.seg-banner-orange { color: #FF771C; }
.seg-banner-desc {
  font-size: 16px;
  line-height: 1.75;
  color: rgba(255,255,255,0.75);
  margin: 0;
  max-width: 480px;
}

/* Demo CTA */
.demo-cta-section {
  background: #F8F6F3;
  padding: 96px 0;
}
.demo-cta-simple {
  max-width: 640px;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}
.demo-cta-simple .demo-cta-title {
  margin: 16px 0 20px;
}
.demo-cta-simple .demo-cta-desc {
  margin: 0 0 32px;
}
.demo-cta-title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.03em;
  color: #1D1D1F;
  margin: 16px 0 20px;
}
.demo-cta-desc {
  font-size: 16px;
  line-height: 1.7;
  color: #86868B;
  margin: 0 0 32px;
}
.demo-cta-form { display: flex; flex-direction: column; gap: 0; }
.demo-cta-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
}
.demo-cta-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.demo-cta-field label {
  font-size: 13px;
  font-weight: 600;
  color: #444;
}
.demo-cta-field input,
.demo-cta-field select {
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 14px;
  color: #1D1D1F;
  outline: none;
  transition: border-color 0.15s;
  appearance: auto;
}
.demo-cta-field input:focus,
.demo-cta-field select:focus {
  border-color: #FF771C;
}
.demo-cta-btn {
  background: #FF771C;
  color: #FFFFFF;
  border: none;
  border-radius: 10px;
  padding: 16px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  text-align: center;
}
.demo-cta-btn:hover { background: #E05F00; }

.demo-cta-consultoria {
  margin-top: 20px;
  font-size: 14px;
  color: #86868B;
}
.demo-cta-consultoria-link {
  color: #FF771C;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}
.demo-cta-consultoria-link:hover {
  text-decoration: underline;
}

/* New Footer */
.new-footer {
  background: #F8F6F3;
  border-top: 1px solid #E5E5EA;
  padding: 0;
}
.new-footer-status-bar {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #86868B;
  border-bottom: 1px solid #E5E5EA;
}
.status-dot-green {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34C759;
  flex-shrink: 0;
}
.footer-status-link {
  color: #FF771C;
  text-decoration: none;
}
.new-footer-links-row {
  max-width: 1100px;
  margin: 0 auto;
  padding: 48px 32px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 32px;
}
.footer-col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer-col-title {
  font-size: 13px;
  font-weight: 700;
  color: #1D1D1F;
  margin-bottom: 4px;
}
.footer-link {
  font-size: 13px;
  color: #86868B;
  text-decoration: none;
  transition: color 0.15s;
}
.footer-link:hover { color: #1D1D1F; }
.footer-link--orange { color: #FF771C; }
.footer-link--orange:hover { color: #E05F00; }
.new-footer-bottom {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 32px;
  border-top: 1px solid #E5E5EA;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.new-footer-partners {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-top: 1px solid #E5E5EA;
}
.footer-partners-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #86868B;
  text-transform: uppercase;
}
.footer-partners-logos {
  display: flex;
  align-items: center;
  gap: 32px;
}
.footer-partner-logo {
  height: 80px;
  width: auto;
  object-fit: contain;
  opacity: 0.85;
  transition: opacity 0.2s;
}
.footer-partner-logo:hover { opacity: 1; }
.footer-copy-new {
  font-size: 13px;
  color: #86868B;
}
.footer-locale {
  font-size: 13px;
  color: #86868B;
}

/* Segurança/Demo responsive */
@media (max-width: 960px) {
  .seg-title { font-size: 36px; }
  .seg-banner-title { font-size: 36px; }
  .seg-stat-num { font-size: 56px; }
  .demo-cta-title { font-size: 32px; }
  .new-footer-links-row { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 600px) {
  .sec-seguranca, .seg-stats-section, .demo-cta-section { padding: 64px 0 48px; }
  .sec-seg-inner, .seg-stats-inner, .seg-notice-bar, .demo-cta-simple { padding: 0 20px; }
  .seg-title { font-size: 28px; }
  .seg-pills { gap: 8px; }
  .seg-pill { font-size: 12px; padding: 8px 14px; }
  .seg-stats-inner { flex-direction: column; gap: 32px; }
  .seg-stat-divider { display: none; }
  .seg-stat-num { font-size: 48px; }
  .seg-banner-inner { padding: 60px 20px; margin-left: 0; }
  .seg-banner-title { font-size: 28px; }
  .demo-cta-title { font-size: 26px; }
  .new-footer-links-row { grid-template-columns: repeat(2, 1fr); gap: 24px; padding: 32px 20px; }
  .new-footer-bottom { flex-direction: column; gap: 8px; text-align: center; padding: 16px 20px; }
  .new-footer-status-bar { padding: 16px 20px; }
}

/* ============ DEPOIMENTOS SECTION (LEGACY – hidden) ============ */
.depoimentos-section {
  background: #FAFAFA;
  padding: 96px 0;
}

.depoimentos-header {
  text-align: center;
  margin-bottom: 56px;
}

.depoimentos-label {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #FF771C;
  margin-bottom: 16px;
}

.depoimentos-title {
  font-size: 40px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1D1D1F;
  line-height: 1.15;
}

.depoimentos-grid {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.depoimento-card {
  background: white;
  border: 1px solid #F0F0F0;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  transition: all 0.2s;
}

.depoimento-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.depoimento-stars {
  display: flex;
  gap: 2px;
  margin-bottom: 20px;
}

.star {
  color: #FF771C;
  font-size: 18px;
}

.depoimento-text {
  font-size: 15px;
  line-height: 1.7;
  color: #444;
  flex: 1;
  margin-bottom: 24px;
}

.depoimento-divider {
  height: 1px;
  background: #F0F0F0;
  margin-bottom: 20px;
}

.depoimento-name {
  font-size: 15px;
  font-weight: 600;
  color: #1D1D1F;
  margin-bottom: 2px;
}

.depoimento-role {
  font-size: 13px;
  color: #86868B;
}

/* Depoimentos responsive */
@media (max-width: 960px) {
  .depoimentos-title {
    font-size: 30px;
  }

  .depoimentos-grid {
    grid-template-columns: 1fr;
    max-width: 520px;
    gap: 20px;
  }
}

@media (max-width: 600px) {
  .depoimentos-section {
    padding: 64px 0;
  }

  .depoimentos-grid {
    padding: 0 20px;
  }

  .depoimento-card {
    padding: 24px;
  }
}

/* ============ TRUST BAR ============ */
.trust-section {
  background: #FAFAFA;
  padding: 48px 0 64px;
}

.trust-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.trust-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.trust-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 14px;
  background: #FFF3EB;
}

.trust-title {
  font-size: 16px;
  font-weight: 600;
  color: #1D1D1F;
  margin-bottom: 4px;
}

.trust-desc {
  font-size: 14px;
  color: #86868B;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .trust-container {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}

/* ============ CTA SECTION ============ */
.cta-section {
  position: relative;
  background: #FFF3EB;
  padding: 96px 0;
  text-align: center;
  overflow: hidden;
}

.cta-wave {
  position: absolute;
  top: -1px;
  left: 0;
  right: 0;
  height: 48px;
  background: #FAFAFA;
  border-radius: 0 0 50% 50%;
}

.cta-container {
  position: relative;
  z-index: 1;
  max-width: 640px;
  margin: 0 auto;
  padding: 0 32px;
}

.cta-title {
  font-size: 40px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1D1D1F;
  margin-bottom: 16px;
  line-height: 1.15;
}

.cta-desc {
  font-size: 16px;
  color: #86868B;
  line-height: 1.6;
  margin-bottom: 36px;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cta-btn-primary {
  display: inline-flex;
  align-items: center;
  background: #FF771C;
  color: white;
  border: none;
  padding: 16px 36px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cta-btn-primary:hover {
  background: #E8691A;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 119, 28, 0.35);
}

.cta-btn-secondary {
  display: inline-flex;
  align-items: center;
  background: white;
  color: #1D1D1F;
  border: 1px solid #E0E0E0;
  padding: 16px 36px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cta-btn-secondary:hover {
  border-color: #FF771C;
  color: #FF771C;
  transform: translateY(-1px);
}

@media (max-width: 600px) {
  .cta-section {
    padding: 72px 0;
  }

  .cta-title {
    font-size: 28px;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }

  .cta-btn-primary,
  .cta-btn-secondary {
    width: 100%;
    justify-content: center;
  }
}

/* ============ FOOTER ============ */
.landing-footer {
  background: #FAFAFA;
  border-top: 1px solid #F0F0F0;
  padding: 24px 0;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  justify-content: flex-end;
}

.footer-copy {
  font-size: 13px;
  color: #86868B;
}

@media (max-width: 600px) {
  .footer-container {
    justify-content: center;
  }
}

/* ============ DEMO DIALOG ============ */
.demo-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.demo-dialog {
  background: #111113;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 40px;
  max-width: 460px;
  width: 100%;
  position: relative;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255,119,28,0.06);
}

.demo-close {
  position: absolute;
  top: 16px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  line-height: 1;
  transition: color 0.15s;
}

.demo-close:hover {
  color: rgba(255, 255, 255, 0.8);
}

.demo-dialog-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #fff;
  letter-spacing: -0.3px;
}

.demo-dialog-sub {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 28px;
  line-height: 1.5;
}

.demo-field {
  margin-bottom: 16px;
}

.demo-field label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.demo-field input,
.demo-field select {
  width: 100%;
  padding: 11px 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
  box-sizing: border-box;
}

.demo-field input::placeholder {
  color: rgba(255, 255, 255, 0.22);
}

.demo-field select option {
  background: #1a1a1c;
  color: #fff;
}

.demo-field input:focus,
.demo-field select:focus {
  border-color: rgba(255, 119, 28, 0.6);
  background: rgba(255, 119, 28, 0.04);
}

.demo-field input:disabled,
.demo-field select:disabled {
  opacity: 0.5;
}

.demo-submit {
  width: 100%;
  background: #FF771C;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.2s;
  letter-spacing: -0.1px;
}

.demo-submit:hover:not(:disabled) {
  background: #FF8C3A;
  box-shadow: 0 4px 20px rgba(255, 119, 28, 0.4);
}

.demo-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.demo-success {
  text-align: center;
  padding: 20px 0;
}

.demo-success-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(52, 199, 89, 0.15);
  border: 1.5px solid rgba(52, 199, 89, 0.5);
  color: #34C759;
  font-size: 26px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.demo-error-msg {
  background: rgba(211, 47, 47, 0.12);
  color: #FF6B6B;
  border: 1px solid rgba(211, 47, 47, 0.35);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 16px;
}

.demo-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: demo-spin 0.6s linear infinite;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes demo-spin {
  to { transform: rotate(360deg); }
}

/* ============ RESPONSIVE ============ */
@media (max-width: 960px) {
  .hero-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .hero-content {
    order: 1;
  }

  .hero-preview {
    order: 2;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-preview-window {
    transform: none;
  }

  .hero-preview-window:hover {
    transform: none;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding-top: 90px;
    padding-bottom: 48px;
  }

  .hero-container {
    padding: 0 20px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-ctas {
    flex-direction: column;
  }

  .hero-btn-primary,
  .hero-btn-secondary {
    width: 100%;
    justify-content: center;
    text-align: center;
  }

  .preview-sidebar {
    width: 100px;
  }

  .preview-metrics {
    flex-wrap: wrap;
  }

  .preview-metric-card {
    min-width: 40%;
  }
}
</style>
